<template>
  <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
    <v-layout v-if="invalidRequest" wrap>
      <v-flex xs12 class="px-4 py-2">
        <v-toolbar dark flat color="secondary">
          <v-toolbar-title :style="$store.state.textFormatting.headers">
            Invalid Episode Data Request 
            <!-- Add the prefix and more info in title -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card v-if="showMain">
          <v-card-text>
            <p>Unfortunately your request could not be processed - No Episode data was found.</p>
            <p>It is possible the data you requested has now been aged off from the system (normally after 30 days) or the url has been corrupted.</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="!invalidRequest" wrap>
      <v-flex v-if="scored_Event_Data" xs12 name="Tables for Episode and Event" class="px-4 py-2">
        <v-toolbar dark flat color="secondary">
          <v-toolbar-title :style="$store.state.textFormatting.headers">
            All events associated with selected alert - {{scored_Event_Data[0].prefix}}
            <!-- Add the prefix and more info in title -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex shrink align-center justify-center>
            <br />
            <v-switch v-model="advanced_fields" @change="advancedChange()">
              <template v-slot:label>
                <div :style="$store.state.textFormatting.main">
                  <b>Advanced Event Fields</b>
                </div>
              </template>
            </v-switch>
          </v-flex>
          <v-flex shrink>
            <v-btn @click="showMain=!showMain" v-if="showMain" dark fab small color="blue">
              <h2>-</h2>
            </v-btn>
            <v-btn @click="showMain=!showMain" v-if="!showMain" dark fab small color="blue">
              <h2>+</h2>
            </v-btn>
          </v-flex>
          <info>
            <template slot>Events associated with selected episode/notification.</template>
            <template slot="body">
              <p>
                The above table displays the episode/notification, followed by a button to display
                <b>similar</b> episodes. Below that is a
                table displaying the events constituting the given episode.
              </p>
              <p>
                Each episode has a prefix, new/ old origin ASNs and a timestamp, along with the hijack and impact scores we have calculated.
                These are an average of all events constituting the given episode. The validation score is a count of all events under this episode.
              </p>

              <ul>
                <li v-for="i in additionalColumns" :key="i.index">
                  <b>{{i.text}}:</b>
                  {{i.value}}
                </li>
              </ul>
              <br />
              <p>
                <b>Similar episodes:</b> defined as an episode with the same prefix and where the new origin ASN is present as either the new/ old origin ASN.
                The default time range is +- 30 mins, but the user can select other timeframes. Episodes can be clicked to bring up a similar page to this, but for the selected episode.
              </p>

              <br />
              <p>
                <b>Click on one of the events (in the bottom table of this card) to see a breakdown of the scoring.</b>
                <br />
              </p>
            </template>
            <template slot="action">
              <v-btn
                to="/searchEvents"
                flat
                color="primary"
                :style="$store.state.textFormatting.main"
              >More Events</v-btn>
            </template>
          </info>
        </v-toolbar>
        <v-card v-if="showMain">
          <v-card-text>
            <v-data-table
              :headers="headersAlert"
              :items="currentEpisodeData"
              :key="id2"
              hide-actions
              v-if="showEpisode"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                  <span
                    slot="activator"
                    :style="$store.state.textFormatting.main"
                  >{{ props.header.text }}</span>
                  <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.prefix }}</td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners">
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :style="$store.state.textFormatting.main"
                        >{{ props.item.origin_asn_old }}</div>
                      </template>
                      <span
                        :style="$store.state.textFormatting.main"
                      >{{ asn_own_dict[props.item.origin_asn_old] }}</span>
                    </v-tooltip>
                    <div v-if="!is_asn_owners" :style="$store.state.textFormatting.main">
                      {{ props.item.origin_asn_old }}
                      <v-progress-circular size="12" indeterminate color="purple" />
                    </div>
                  </td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners.main">
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :style="$store.state.textFormatting.main"
                        >{{ props.item.origin_asn_new }}</div>
                      </template>
                      <span
                        :style="$store.state.textFormatting.main"
                      >{{ asn_own_dict[props.item.origin_asn_new] }}</span>
                    </v-tooltip>
                    <div v-if="!is_asn_owners.main" :style="$store.state.textFormatting.main">
                      {{ props.item.origin_asn_new }}
                      <v-progress-circular size="12" indeterminate color="purple" />
                    </div>
                  </td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.hijack_score_mean }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.impact_score_mean }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.event_count }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.datetime.date }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.datetime.time }}</td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  :value="true"
                  color="success"
                  icon="warning"
                  :style="$store.state.textFormatting.main"
                >No episode data</v-alert>
              </template>
            </v-data-table>
            <v-layout align-left>
              <v-btn
                v-if="hideSimilar"
                color="success"
                @click="hideSimilar=!hideSimilar"
                :style="$store.state.textFormatting.main"
              >SHOW SIMILAR EPISODES</v-btn>
              <v-btn
                v-if="!hideSimilar"
                color="red"
                @click="hideSimilar=!hideSimilar"
                :style="$store.state.textFormatting.main"
              >HIDE SIMILAR EPISODES</v-btn>
              <v-flex v-if="!showSimilarLoad">
                <h4
                  v-if="!hideSimilar&&!showSimilarLoad"
                  class="text-xs-center"
                  :style="$store.state.textFormatting.main"
                >Similar Episodes in the {{ timeSimilar }}</h4>
              </v-flex>
              <v-menu open-on-hover v-if="!hideSimilar">
                <template v-slot:activator="{ on }">
                  <v-btn outline v-on="on">
                    <v-toolbar-title>
                      <h4 :style="$store.state.textFormatting.main">Hours back</h4>
                    </v-toolbar-title>
                  </v-btn>
                </template>
                <v-list v-for="i in orderByList" :key="i.param">
                  <v-list-tile @click="refreshList(i.param)">
                    <v-list-tile-title :style="$store.state.textFormatting.main">{{i.name}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-layout>
            <v-data-table
              :headers="headersAlert"
              :items="similarEpisodes"
              :key="id2"
              v-if="!hideSimilar&&!showSimilarLoad"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination3"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                  <span
                    slot="activator"
                    :style="$store.state.textFormatting.main"
                  >{{ props.header.text }}</span>
                  <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <tr
                  @click="clickHandlerEpisode(props.item.prefix, 
                                            props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min)"
                >
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.prefix }}</td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners.similar">
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :style="$store.state.textFormatting.main"
                        >{{ props.item.origin_asn_old }}</div>
                      </template>
                      <span
                        :style="$store.state.textFormatting.main"
                      >{{ asn_own_dict[props.item.origin_asn_old] }}</span>
                    </v-tooltip>
                    <div v-if="!is_asn_owners.similar" :style="$store.state.textFormatting.main">
                      {{ props.item.origin_asn_old }}
                      <v-progress-circular size="12" indeterminate color="purple" />
                    </div>
                  </td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners.similar">
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :style="$store.state.textFormatting.main"
                        >{{ props.item.origin_asn_new }}</div>
                      </template>
                      <span
                        :style="$store.state.textFormatting.main"
                      >{{ asn_own_dict[props.item.origin_asn_new] }}</span>
                    </v-tooltip>
                    <div v-if="!is_asn_owners.similar" :style="$store.state.textFormatting.main">
                      {{ props.item.origin_asn_new }}
                      <v-progress-circular size="12" indeterminate color="purple" />
                    </div>
                  </td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.hijack_score_mean }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.impact_score_mean }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.event_count }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.datetime.date }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.datetime.time }}</td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  :value="true"
                  color="success"
                  icon="warning"
                  :style="$store.state.textFormatting.main"
                >No similar episodes in the {{ timeSimilar }}</v-alert>
              </template>
            </v-data-table>
            <v-progress-circular indeterminate color="purple" v-if="showSimilarLoad" />

            <v-data-table
              :headers="headersEvent"
              :items="scored_Event_Data"
              :key="id"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip top eager>
                  <span
                    slot="activator"
                    :style="$store.state.textFormatting.main"
                  >{{ props.header.text }}</span>
                  <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <tr
                  @click="clickHandler(props.item.score_breakdown, props.item.score_breakdown_array)"
                >
                  <td :style="$store.state.textFormatting.main">{{ props.item.derived_type }}</td>
                  <td :style="$store.state.textFormatting.main">{{ props.item.exact_time }}</td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners.event">
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :style="$store.state.textFormatting.main"
                        >{{ props.item.peer_asn }}</div>
                      </template>
                      <span
                        :style="$store.state.textFormatting.main"
                      >{{ asn_own_dict[props.item.peer_asn] }}</span>
                    </v-tooltip>
                    <div v-if="!is_asn_owners.event" :style="$store.state.textFormatting.main">
                      {{ props.item.peer_asn }}
                      <v-progress-circular size="12" indeterminate color="purple" />
                    </div>
                    ({{ props.item.peer_ip }})
                  </td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="event_indirect_prefix"
                  >{{ props.item.non_direct_prefix }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="!event_indirect"
                  >{{ props.item.path_old }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="event_indirect"
                  >{{ props.item.non_direct_asn_type }}</td>

                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.path_new }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.hijack_score }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.impact_score }}</td>
                  <!-- <td class="text-xs-center" :style="$store.state.textFormatting.main">{{ props.item.sub_hijack_score }}</td>
                  <td class="text-xs-center" :style="$store.state.textFormatting.main">{{ props.item.sub_impact_score }}</td>-->
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.event_count }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.hijack_scope }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.hijack_subtype }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.controlled_pre_show }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.edit_distance }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.pathchange_type }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.common_owner }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.asn_geocomparison }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.prefix_vs_asn_geo }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.bogon }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.route_leak_flag }}</td>
                  <td
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                    v-if="advanced_fields"
                  >{{ props.item.restricted_dns }}</td>
                  <!--<td class="text-xs-center" :style="$store.state.textFormatting.main" v-if="advanced_fields">{{ props.item.registrar_flag }}</td>-->
                  <td
                    v-if="checker_local"
                    class="text-xs-center"
                    :style="$store.state.textFormatting.main"
                  >{{ props.item.event_expanded }}</td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  :value="true"
                  color="success"
                  icon="warning"
                  :style="$store.state.textFormatting.main"
                >No event data</v-alert>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <downloadcsv class="btn btn-default" :data="scored_Event_Data" name="events.csv">
              <v-tooltip top eager color="primary" id="exit-app" v-if="scored_Event_Data">
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    dark
                    v-on="on"
                    color="success"
                    :style="$store.state.textFormatting.main"
                  >
                    <v-icon>save_alt</v-icon>Scored event(s)
                  </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Download Scored events</span>
              </v-tooltip>
            </downloadcsv>
            <v-spacer></v-spacer>
            <v-tooltip top color="primary" id="exit-app" v-if="downloadLinkData">
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  dark
                  v-on="on"
                  color="success"
                  @click="routeNewWindow('Request Raw Data')"
                  :style="$store.state.textFormatting.main"
                >
                  <v-icon>keyboard_return</v-icon>Raw Messages
                </v-btn>
              </template>
              <span
                :style="$store.state.textFormatting.main"
              >Go to raw data download page to create download job</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout  v-if="!invalidRequest" wrap>
      <v-flex xs12 xl5 class="px-4">
        <v-layout wrap>
          <v-flex xs12 v-if="showBD" class="py-2">
            <!-- <v-card>
              <v-toolbar dark color="secondary">
                <v-toolbar-title
                  :style="$store.state.textFormatting.headers"
                >Score breakdown for selected event</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="showBDstr=!showBDstr" color="success">
                  <h4 v-if="showBDstr" :style="$store.state.textFormatting.main">SHOW TABLE</h4>
                  <h4 v-if="!showBDstr" :style="$store.state.textFormatting.main">SHOW STEPS</h4>
                </v-btn>
                <v-btn @click="showBD=!showBD" dark fab small color="blue">
                  <h2>-</h2>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="showBDstr">
                <ol type="1">
                  <li
                    v-for="line in scoreBD"
                    :key="line.index"
                    :style="$store.state.textFormatting.main"
                  >{{ line }}</li>
                </ol>
              </v-card-text>
              <v-data-table
                v-if="!showBDstr"
                :headers="headersBD"
                :items="scoreBDarray"
                :key="id"
                :hide-default-footer="true"
                :pagination.sync="pagination2"
                hide-actions
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip top eager>
                    <span
                      slot="activator"
                      :style="$store.state.textFormatting.main"
                    >{{ props.header.text }}</span>
                    <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                  </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.name }}</td>
                    <td
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.h }}</td>
                    <td
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.i }}</td>
                    <td
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.exp }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card> -->
          </v-flex>

          <!--
          <v-flex xs12 name="bar chart" class="py-2">
            <v-card>
              <v-toolbar dark color="secondary">
                <v-toolbar-title :style="$store.state.textFormatting.headers">Episode/Notification Score vs Threshold Score</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <v-btn @click="showBar=!showBar" v-if="showBar" dark fab small color="blue"><h2> - </h2></v-btn>
                    <v-btn @click="showBar=!showBar" v-if="!showBar" dark fab small color="blue"><h2> + </h2></v-btn>
                </v-flex>
                <info>
                  <template slot>Alert Score vs Threshold Score Graph</template>
                  <template slot="body">
                    <p>Each ASN for an organisation has a different Hijack, Impact and Validation threshold score.</p>
                    <br />
                    <p>This graph helps to visualise a comparison between the Episode/Notification scores and the users ASN scores</p>
                  </template>
                  <template slot="action">
                    <v-btn to="/asnSettings" flat color="primary">View/Edit ASN thresholds</v-btn>
                  </template>
                </info>
              </v-toolbar>
              <v-card-text v-if="showBar">
                <bar-chart :chart-data="graphdata" :options="options" key="id"></bar-chart>
              </v-card-text>
            </v-card>
          </v-flex>
          -->

          <v-flex xs12 class="py-2">
            <disag v-if="send_disag" :disag_events="disag_events"></disag>
            <v-progress-circular indeterminate color="purple" v-if="!send_disag" />
          </v-flex>
          <v-flex xs12 name="prefix Routing" class="py-2">
            <prefixRouting :prefixProp="prefixInQ"></prefixRouting>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 xl7 class="px-4">
        <v-layout wrap v-if="mult_show_banner">
          <v-flex xs12 class="py-2">
            <v-toolbar dark flat color="secondary">
              <v-toolbar-title :style="$store.state.textFormatting.headers">{{ mult_title }}</v-toolbar-title>
              <v-progress-circular indeterminate color="purple" v-if="mult_loading" />
              <v-flex class="px-2">
                <v-tooltip top eager color="primary" id="exit-app" v-if="mult_message">
                  <template v-slot:activator="{ on }" v-if="mult_message">
                    <v-chip
                      :style="$store.state.textFormatting.main"
                      v-on="on"
                      :color="mult_msg_colour"
                    >{{ mult_message }}</v-chip>
                  </template>
                  <span
                    :style="$store.state.textFormatting.main"
                    v-if="mult_message"
                  >{{ mult_msg_tooltip }}</span>
                </v-tooltip>
              </v-flex>
              <v-spacer />
              <downloadcsv
                class="btn btn-default"
                :data="mult_all_episodes"
                name="recentAlerts.csv"
                v-if="mult_show"
              >
                <v-tooltip top eager color="primary" id="exit-app" v-if="mult_show">
                  <template v-slot:activator="{ on }" v-if="mult_show">
                    <v-btn
                      small
                      dark
                      v-on="on"
                      color="success"
                      v-if="mult_show"
                      :style="$store.state.textFormatting.main"
                    >
                      <v-icon>save_alt</v-icon>recent alerts
                    </v-btn>
                  </template>
                  <span
                    :style="$store.state.textFormatting.main"
                  >Download recent alerts for this ASN</span>
                </v-tooltip>
              </downloadcsv>
              <v-flex shrink>
                <v-btn @click="flipMult" v-if="mult_show" dark fab small color="blue">
                  <h2>-</h2>
                </v-btn>
                <v-btn @click="flipMult" v-if="!mult_show" dark fab small color="blue">
                  <h2>+</h2>
                </v-btn>
              </v-flex>
              <info>
                <template slot>Recent Alerts</template>
                <template slot="body">
                  <p>For the hijacking ASN of this alert (the new ownership ASN), this window shows the alerts in the last/future 30 mins (of the alerts happening)</p>
                </template>
                <!-- <template slot="action">
                                        <v-btn flat color="primary" to="/ASNBaseline"> MORE ASN INFO</v-btn>
                </template> !-->
              </info>
            </v-toolbar>
            <v-card v-if="mult_show">
              <v-container grid-list-xl>
                <v-layout justify-center align-center wrap>
                  <v-flex>
                    <v-btn
                      v-if="mult_show_all"
                      @click="mult_show_all=!mult_show_all"
                      color="success"
                      :style="$store.state.textFormatting.main"
                    >Show Summary</v-btn>
                    <v-btn
                      v-if="!mult_show_all"
                      @click="mult_show_all=!mult_show_all"
                      color="success"
                      :style="$store.state.textFormatting.main"
                    >Show Alerts</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!mult_show_all">
                  <v-flex>
                    <v-data-table
                      :headers="mult_sum_headers"
                      :items="mult_tally"
                      :key="id"
                      :pagination.sync="mult_pagination_3"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                          <span
                            slot="activator"
                            :style="$store.state.textFormatting.main"
                          >{{ props.header.text }}</span>
                          <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.prefix }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.asserting_over }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.asserted_over }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.path_change }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.first_seen }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>

                <v-layout justify-center align-center wrap v-if="mult_show_all">
                  <v-flex>
                    <v-data-table
                      :headers="headersAlert"
                      :items="mult_all_episodes"
                      :key="id"
                      :pagination.sync="mult_pagination_2"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                          <span
                            slot="activator"
                            :style="$store.state.textFormatting.main"
                          >{{ props.header.text }}</span>
                          <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr
                          @click="clickHandlerEpisode(props.item.prefix, 
                                                        props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min)"
                        >
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.prefix }}</td>

                          <td class="text-xs-center" :style="$store.state.textFormatting.main">
                            <v-tooltip
                              top
                              eager
                              color="primary"
                              id="exit-app"
                              v-if="is_asn_owners.multiple"
                            >
                              <template v-slot:activator="{ on }">
                                <div
                                  v-on="on"
                                  :style="$store.state.textFormatting.main"
                                >{{ props.item.origin_asn_old }}</div>
                              </template>
                              <span
                                :style="$store.state.textFormatting.main"
                              >{{ asn_own_dict[props.item.origin_asn_old] }}</span>
                            </v-tooltip>
                            <div
                              v-if="!is_asn_owners.multiple"
                              :style="$store.state.textFormatting.main"
                            >
                              {{ props.item.origin_asn_old }}
                              <v-progress-circular size="12" indeterminate color="purple" />
                            </div>
                          </td>
                          <td class="text-xs-center" :style="$store.state.textFormatting.main">
                            <v-tooltip
                              top
                              eager
                              color="primary"
                              id="exit-app"
                              v-if="is_asn_owners.multiple"
                            >
                              <template v-slot:activator="{ on }">
                                <div
                                  v-on="on"
                                  :style="$store.state.textFormatting.main"
                                >{{ props.item.origin_asn_new }}</div>
                              </template>
                              <span
                                :style="$store.state.textFormatting.main"
                              >{{ asn_own_dict[props.item.origin_asn_new] }}</span>
                            </v-tooltip>
                            <div
                              v-if="!is_asn_owners.multiple"
                              :style="$store.state.textFormatting.main"
                            >
                              {{ props.item.origin_asn_new }}
                              <v-progress-circular size="12" indeterminate color="purple" />
                            </div>
                          </td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.hijack_score_mean }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.impact_score_mean }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.event_count }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.datetime.date }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.datetime.time }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout wrap v-if="tr_show_panel">
          <v-flex xs12 class="py-2">
            <v-toolbar dark flat color="secondary">
              <v-toolbar-title :style="$store.state.textFormatting.headers">{{ tr_title }}</v-toolbar-title>
              <v-progress-circular indeterminate color="purple" v-if="tr_loading" />
              <v-spacer />
              <downloadcsv class="btn btn-default" :data="tr_full_download" name="traceroute.csv">
                <v-tooltip top eager color="primary" id="exit-app" v-if="tr_show_results">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      dark
                      v-on="on"
                      color="success"
                      :style="$store.state.textFormatting.main"
                    >
                      <v-icon>save_alt</v-icon>Traceroute
                    </v-btn>
                  </template>
                  <span :style="$store.state.textFormatting.main">Download All Traceroutes</span>
                </v-tooltip>
              </downloadcsv>
              <v-flex shrink>
                <v-btn @click="flipTr" v-if="tr_show_card" dark fab small color="blue">
                  <h2>-</h2>
                </v-btn>
                <v-btn @click="flipTr" v-if="!tr_show_card" dark fab small color="blue">
                  <h2>+</h2>
                </v-btn>
              </v-flex>
              <info>
                <template slot>Parallel Traceroute</template>
                <template slot="body">
                  <p>
                    <b>WHAT IS A PARALLEL TRACEROUTE?</b>
                  </p>
                  <p>
                    A parallel trace route is a way of executing a traceroute which uses thread concurrency to get the result substantially faster than if the packets were sent sequentially.
                    Fundamentally, traceroutes work by sending out packets with sequentially rising TTLs, and combining the IP addresses of the responses. This requires very little computational effort, but a lot of waiting for network responses.
                    <br />If the packets are sent sequentially, (
                    <b>standard</b>) a traceroute which finds its target might take around 10s to return.
                    <br />If the packets are sent concurrently, (
                    <b>parallel</b>) assuming a packet timeout of 1s, the result will come back in no more than 1s.
                    <br />For a system like ours, because we send a lot of traceroutes, we need each traceroute to return in around 0.5s, which is less than the minimum sensible timeout for packets.
                    That means we need to send multiple parallel traceroutes concurrently, which is not difficult with modern asynchronous web servers.
                    Finally, each traceroute is requested from different starting locations around the world. This is achieved by deploying the same API into different AWS datacenters.
                  </p>
                  <v-divider />
                  <p><b>Node colours</b><br />
                    <v-chip color="red" :style="$store.state.textFormatting.main">red</v-chip>in the second traceroute denotes new IP addresses,
                    up to the last octet (i.e. if 1.1.1.1 is in the present in the first TR, 1.1.2.1 would be red in the second, but 1.1.1.2 will be blue in the second)<br />
                    <v-chip color="blue" :style="$store.state.textFormatting.main">blue</v-chip>in the second traceroute denotes no change in the IP addresses (not including the last octet)<br>
                    <v-chip color="grey" :style="$store.state.textFormatting.main">grey</v-chip>in either traceroute when displaying ASNs denotes reserved or reserved (RFC1112) or shared (RFC6598) IP ranges are in use for that hop - these are not owned by any ASN and are used for routing while inside an AS.<br>
                  </p>
                  <p><b>Click on the TOGGLE IP/ASN button</b> to switch to the ASN (or IP) view. The IP addresses in the traceroute are matched to the nearest known IP Prefix and it's associated ASN</p>
                  <p><b>Click on any node</b> in the traceroute to view more information about it (IP address, ASN, ASN owner)</p>
                  <p><b>Click on the TRIGGER MANUAL TRACEROUTE</b> to run an additional traceroute now. The request will be queued and run within about 10 seconds and while update and show the results when complete. This can be run as often as you like but will replace the results of a previous manual traceroute.<br />
                  NOTE: the results are only visible to you - no other user of the system will see the result of your manual traceroute</p>
                  <p><b>Select either one of the datacentre regions</b> to see the individual traceroute result, or choose 'All' to see these amalgamated</p>
                  <p>
                    <b>NOTE:</b> With 'All' selected, the node diagram will stay still until you press the
                    <b>1</b> or
                    <b>2</b>, which will alternate the display of links between the 2 diagrams.
                  </p>
                  <v-divider />
                  <p>
                    <b>IMPORTANT:</b> Traceroutes will
                    <b>ONLY</b> run where an alert has been generated for the given event
                    i.e. a user somewhere in the system is monitoring one of the ASNs involved or the prefix.
                  </p>
                </template>
              </info>
            </v-toolbar>
            <v-card v-if="tr_show_card">
              <v-container grid-list-xl>
                <v-layout justify-center align-center wrap>
                  <v-flex>
                    <v-btn
                      v-for="i in this.tr_keys"
                      :key="i.index"
                      @click="selectTrSource(i.name)"
                      :color="i.color"
                      :style="$store.state.textFormatting.main"
                    >{{ i.name }}</v-btn>
                  </v-flex>
                  <v-spacer />
                  <v-flex>
                    <v-btn
                      color="accent"
                      @click="switchTrIpAsn()"
                      :style="$store.state.textFormatting.main"
                    >Toggle IP/ASN</v-btn>
                    <v-btn
                      @click="selectTrSource('All')"
                      :color="tr_all_color"
                      :style="$store.state.textFormatting.main"
                    >All</v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      :disabled="!tr_show_all_1"
                      dark
                      @click="refreshFirst"
                      color="success"
                      :style="$store.state.textFormatting.main"
                    >1</v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      :disabled="!tr_show_all_2"
                      dark
                      @click="refreshSecond"
                      color="success"
                      :style="$store.state.textFormatting.main"
                    >2</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="showNodeDetails">
                    <v-flex xs6 md6 xl6>
                        <v-card>
                          <v-toolbar dark class="secondary">
                            <v-toolbar-title>Hop Detail</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn icon @click.native="showNodeDetails = false" dark>
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-toolbar-items>
                          </v-toolbar>

                          <v-card-text>
                              <div display-1 :style="$store.state.textFormatting.main"> IP - {{ tr_ip }} </div>
                              <div display-1 :style="$store.state.textFormatting.main"> Prefix - {{ tr_parentPrefix }} </div>
                              <div display-1 :style="$store.state.textFormatting.main"> ASN - {{ tr_asn }} </div>
                              <div display-1 :style="$store.state.textFormatting.main"> AS Owner - {{ tr_asowner }} </div>
                          </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!tr_show_all_1&&!tr_show_all_2">
                  <v-flex v-if="tr_show_results" class="text-xs-center" justify-center align-center>
                    <div class="text-xs-center tr-back" justify-center align-center>First Traceroute</div>
                    <div class="text-xs-center" justify-center align-center>
                      <d3-network
                        ref="net"
                        :net-nodes="tr_nodes_1"
                        :net-links="tr_links_1"
                        :options="tr_options"
                        @node-click="nodeClick"
                      ></d3-network>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!tr_show_all_1&&!tr_show_all_2">
                  <v-flex v-if="tr_show_results" class="text-xs-center" justify-center align-center>
                    <div class="text-xs-center tr-back" justify-center align-center>Second Traceroute</div>
                    <div class="text-xs-center" justify-center align-center>
                      <d3-network
                        ref="net"
                        :net-nodes="tr_nodes_2"
                        :net-links="tr_links_2"
                        :options="tr_options"
                        @node-click="nodeClick"
                      ></d3-network>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="manTrRun&&!tr_show_all_1&&!tr_show_all_2">
                  <v-flex v-if="tr_show_results" class="text-xs-center" justify-center align-center>
                    <div class="text-xs-center tr-back" justify-center align-center>Manual Traceroute</div>
                    <div class="text-xs-center" justify-center align-center>
                      <d3-network
                        ref="net"
                        :net-nodes="tr_nodes_man"
                        :net-links="tr_links_man"
                        :options="tr_options"
                        @node-click="nodeClick"
                      ></d3-network>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!tr_show_all_1&&!tr_show_all_2">
                  <v-flex v-if="tr_show_results">
                    <div
                      class="text-xs-center"
                      v-if="tr_ts_1"
                      :style="$store.state.textFormatting.main"
                    >1st TR: {{ tr_ts_1 }}</div>
                    <div
                      class="text-xs-center"
                      v-if="tr_ts_2"
                      :style="$store.state.textFormatting.main"
                    >2nd TR: {{ tr_ts_2 }}</div>
                    <div
                      class="text-xs-center"
                      v-if="manTrRun"
                      :style="$store.state.textFormatting.main"
                    >Manual TR: {{ tr_ts_man }}</div>
                    <div
                      class="text-xs-center"
                      v-if="manTrQueued"
                      :style="$store.state.textFormatting.main"
                    >Manual TR: Pending</div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!tr_show_all_1&&!tr_show_all_2">
                  <v-flex>Select Traceroute Table
                    <v-btn
                      :color="tr_table_select_1_colour"
                      @click="set_tr_table_select(1)"
                      :style="$store.state.textFormatting.main"
                    >1</v-btn>
                    <v-btn
                      :color="tr_table_select_2_colour"
                      @click="set_tr_table_select(2)"
                      :style="$store.state.textFormatting.main"
                    >2</v-btn>
                    <v-btn
                      :disabled="!manTrRun"
                      :color="tr_table_select_man_colour"
                      @click="set_tr_table_select(3)"
                      :style="$store.state.textFormatting.main"
                    >Manual</v-btn>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex>
                    <v-btn
                      v-if="!manTrQueued && !manTrRun"
                      class="accent"
                      @click="triggerManualTraceroute"
                      :disabled="manTrQueued"
                      :style="$store.state.textFormatting.main"
                    >Trigger Manual Traceroute</v-btn>
                    <v-btn
                      v-if="!manTrQueued && manTrRun"
                      class="accent"
                      @click="triggerManualTraceroute"
                      :disabled="manTrQueued"
                      :style="$store.state.textFormatting.main"
                    >Trigger Another Manual Traceroute</v-btn>
                    <v-btn
                      v-if="manTrQueued"
                      class="accent"
                      @click="triggerRefreshManTraceRoute"
                      text
                      >
                      Pending <v-progress-circular indeterminate color="white" />
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="!tr_show_all_1&&!tr_show_all_2">
                  <v-flex v-if="tr_show_results">
                    <v-data-table
                      v-if="tr_show_results && tr_table_select_1"
                      :headers="tr_headers"
                      :items="tr_table_1"
                      :key="id"
                      :hide-default-footer="true"
                      :pagination.sync="tr_pagination"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                          <span
                            slot="activator"
                            :style="$store.state.textFormatting.main"
                          >{{ props.header.text }}</span>
                          <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.TTL }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.ip_address }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.asn }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.time }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-data-table
                      v-if="tr_show_results && tr_table_select_2"
                      :headers="tr_headers"
                      :items="tr_table_2"
                      :key="id"
                      :hide-default-footer="true"
                      :pagination.sync="tr_pagination"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                          <span
                            slot="activator"
                            :style="$store.state.textFormatting.main"
                          >{{ props.header.text }}</span>
                          <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.TTL }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.ip_address }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.asn }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.time }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-data-table
                      v-if="tr_show_results && tr_table_select_man"
                      :headers="tr_headers"
                      :items="tr_table_man"
                      :key="id"
                      :hide-default-footer="true"
                      :pagination.sync="tr_pagination"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                          <span
                            slot="activator"
                            :style="$store.state.textFormatting.main"
                          >{{ props.header.text }}</span>
                          <span :style="$store.state.textFormatting.main">{{ props.header.ad_text }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.TTL }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.ip_address }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.asn }}</td>
                          <td
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                          >{{ props.item.time }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="tr_show_all_1">
                  <v-flex v-if="tr_show_results">
                    <div class="text-xs-center tr-back" justify-center align-center>First Traceroute</div>
                    <div class="text-xs-center">
                      <d3-network
                        ref="net"
                        :net-nodes="tr_all_nodes_1"
                        :net-links="tr_all_links_1"
                        :options="tr_all_options_1"
                        @node-click="nodeClick"
                      ></d3-network>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="tr_show_all_2">
                  <v-flex v-if="tr_show_results">
                    <div class="text-xs-center tr-back" justify-center align-center>Second Traceroute</div>
                    <div class="text-xs-center">
                      <d3-network
                        ref="net"
                        :net-nodes="tr_all_nodes_2"
                        :net-links="tr_all_links_2"
                        :options="tr_all_options_2"
                        @node-click="nodeClick"
                      ></d3-network>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-center wrap v-if="tr_show_all_1">
                  <v-flex v-if="tr_show_results">
                    <div
                      class="text-xs-center"
                      v-if="tr_ts_1"
                      :style="$store.state.textFormatting.main"
                    >First TR: {{ tr_ts_1 }}</div>
                    <div
                      class="text-xs-center"
                      v-if="tr_ts_2"
                      :style="$store.state.textFormatting.main"
                    >Second TR: {{ tr_ts_2 }}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 name="path chang vis" class="py-2">
            <asnpathchange
              v-bind:pathDataBefore="oldAndNewPath.pathsBeforeAnnomaly"
              v-bind:pathDataAfter="oldAndNewPath.pathsAfterAnnomaly"
              :key="idForPath"
            ></asnpathchange>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import BarChart from "../../shared/operational/BarChart.js";
import info from "../../shared/operational/infopopout.vue";
import asnpathchange from "../../shared/developing/asn-path-change.vue";
import prefixRouting from "../../shared/developing/prefix-routing.vue";
import disag from "../../shared/operational/disag-for-alert.vue";
import { combinedEpisodeNotificationAlertTable } from "../../shared/operational/infopopout.js";
import downloadcsv from "vue-json-csv";
import D3Network from "vue-d3-network";
import { findParentComponentByName } from "../utils/findParent.js";
import moment from 'moment-timezone';


export default {
  name: "AlertFromTop10",
  components: {
    BarChart,
    info,
    asnpathchange,
    prefixRouting,
    disag,
    downloadcsv,
    D3Network,
  },
  data() {
    return {
      tz:'UTC',
      showMain: true,
      downloadLinkData: [],
      infoEvEpNo: combinedEpisodeNotificationAlertTable,
      size: "xs12",
      currentEpisodeData: [],
      hideSimilar: true,
      timeSimilar: "past/ future 30m",
      orderByList: [
        { name: "+- 30 mins", param: "0" },
        { name: "1h", param: "1" },
        { name: "2h", param: "2" },
        { name: "6h", param: "6" },
        { name: "12h", param: "12" },
      ],
      headersAlert: [
        { text: "Episode Prefix", value: "prefix", align: "centre" },

        //{ text: "Ep. New AS Owner", value: "new_owner", align: "centre" },
        { text: "Ep. Old Origin", value: "origin_asn_old", align: "centre" },
        { text: "Ep. New Origin", value: "origin_asn_new", align: "centre" },
        //{ text: "Ep. Old AS Owner", value: "old_owner", align: "centre" },
        { text: "H Score", value: "hijack_score_mean", align: "centre" },
        { text: "I Score", value: "impact_score_mean", align: "centre" },
        { text: "V Score", value: "event_count", align: "centre" },
        { text: "Date", value: "time_5min", align: "centre" },
        { text: "Time", value: "time_5min", align: "centre" },
      ],
      headersBD: [
        { text: "Analytic", value: "name", align: "centre", sortable: false },
        { text: "Hijack", value: "h", align: "centre", sortable: false },
        { text: "Impact", value: "i", align: "centre", sortable: false },
        { text: "Explanation", value: "exp", align: "centre", sortable: false },
      ],
      showBDstr: false,
      scored_Event_Data: false,
      paramsCombined: null,
      additionalColumns: [
        {
          text: "Repeat Event Count",
          value:
            "how many times this exact event has occurred in the 5 minute period",
          align: "centre",
          sortable: false,
        },
        {
          text: "Hijack Scope",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Hijack Subtype",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Restricted Prefix",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Edit Distance",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Pathchange Type",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Common Owner",
          value: "see glossary",
          align: "centre",
        },
        {
          text: "ASN Geocomparison",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Prefix vs ASN Geo",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Bogon",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Route Leak",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        {
          text: "Restricted DNS",
          value: "see glossary",
          align: "centre",
          sortable: false,
        },
        /*{
          text: "Registrar Flag",
          value: "see glossary",
          align: "centre",
          sortable: false
        }*/
      ],
      headersEvent: [
        { text: "Event Type", value: "ev_type", align: "centre" },

        {
          text: "Exact Time",
          value: "exact_time",
          ad_text: "Exact time this event occurred",
          align: "centre",
        },

        {
          text: "Peer ASN (IP)",
          value: "peer_asn",
          ad_text: "ASN where this advertisment was seen from (the IP address)",
          align: "centre",
        },

        {
          text: "Old ASN Path",
          value: "path_old",
          ad_text: "AS path prior to this event occuring",
          align: "centre",
        },
        {
          text: "New ASN Path",
          value: "path_new",
          ad_text: "AS path after this event occurring",
          align: "centre",
        },
        {
          text: "Hijack Score",
          value: "hijack_score",
          ad_text:
            "How likely the system deems this to be a hijacking event (0 [unlikely] to 99 [very likely])",
          align: "centre",
        },
        {
          text: "Impact Score",
          value: "impact_score",
          ad_text:
            "If this were to be a hijacking event, how impactful would this be to the organisation(s) involved (can be set for 'Restricted Prefixes')",
          align: "centre",
        },
        {
          text: "Repeat Event Count",
          value: "event_count",
          ad_text:
            "How many occurances of this exact event happened in the 5 minute window",
          align: "centre",
        },
        {
          text: "Hijack Scope",
          value: "hijack_scope",
          ad_text:
            "The difference in CIDR of the episode prefix and the prefix having ownership asserted over e.g. if a /24 prefix advertisment occurs, but a /20 prefix is present in the system, the scope will be 4. The scope would be -4 if the prefixes were the other way round. NOTE: If restricted DNS has been hit, this will be the prefix used.",
          align: "centre",
        },
        {
          text: "Hijack Subtype",
          value: "hijack_subtype",
          ad_text:
            "Full: this ownership assertion has not been seen by the system before, Observed: this ownership assertion HAS been seen before, null: not an ownership assertion",
          align: "centre",
        },
        {
          text: "Restricted Prefix",
          value: "controlled_pre_show",
          ad_text:
            "If there's any organisation/ user restricted prefix that has been 'hit' by this event",
          align: "centre",
          sortable: false,
        },
        {
          text: "Edit Distance",
          value: "edit_distance",
          ad_text:
            "The amount of changes (insertion/ replacement/ deletion) to get from the old AS path to the new AS path (accounting for duplicates)",
          align: "centre",
        },
        {
          text: "Path Change Type",
          value: "pathchange_type",
          ad_text: "see. glossary for explanation",
          align: "centre",
        },
        {
          text: "AS Common Owner",
          value: "common_owner",
          ad_text: "If we have a common owner of the new and old ASN, following possibilities: missing - one or more of the ASNs has no ownership, possible - matched but not definite, definite - guaranteed common ownership.",
          align: "centre",
        },
        {
          text: "ASN Geocomparison",
          value: "asn_geocomparison",
          ad_text:
            "Correlation of the old/ new origin ASNs (0 [no correlation] to 1 [perfect correlation])",
          align: "centre",
        },
        {
          text: "Prefix vs ASN Geo",
          value: "prefix_vs_asn_geo",
          ad_text:
            "Correlation of the prefix and new origin ASN (0 [no correlation] to 1 [perfect correlation])",
          align: "centre",
        },
        {
          text: "Bogon",
          value: "bogon",
          ad_text: "If we have a bogon hit, displays here",
          align: "centre",
        },
        {
          text: "Route Leak",
          value: "route_leak_flag",
          ad_text: "1 if route leak (see glossary.), 0 if not a route leak",
          align: "centre",
        },
        {
          text: "Restricted DNS",
          value: "restricted_dns",
          ad_text: "If we have a restricted DNS hit, displays here",
          align: "centre",
          sortable: false,
        },
        /*{
          text: "Registrar Flag",
          value: "registrar_flag",
          ad_text: '0 if prefix is permitted to advertise this prefix, 1 if not',
          align: "centre"
        }*/
      ],
      TestforPushingStuff: false,
      oldAndNewPath: [],
      testPathChange: true,
      graphdata: [],
      invalidRequest: false,
      myData: "",
      showevents: false,
      organisation: "dfdfdfdf",
      user: "",
      showtop10: true,
      manTrQueued:false,
      manTrRun:false,
      manTrTimer: '',
      notification_id: 0,
      radios: null,
      rowsPerPageItems: [10, 20, 30, 40, 50],
      pagination: {
        rowsPerPage: 10,
      },
      pagination2: {
        rowsPerPage: 10,
      },
      pagination3: {
        rowsPerPage: 10,
      },
      showTrASNs: false,
      showNodeDetails: false,
      id: 1,
      id2: 1,
      idForPath: 0,
      graphs: true,
      scoreBD: "",
      showBD: false,
      scoreBDarray: [],
      alertcount: null,
      analytics: null,
      similarEpisodes: [],
      showSimilar: false,
      showSimilarLoad: false,
      expand: true,
      data: [],
      data2: [],
      currentASN: "",
      showEpisode: true,
      prefixInQ: "",
      options: {
        tooltips: {
          titleFontSize:
            this.$store.state.textFormatting.traceroute.fontSize + 10,
          bodyFontSize:
            this.$store.state.textFormatting.traceroute.fontSize + 10,
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
          labels: {
            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Count",
                fontSize:
                  this.$store.state.textFormatting.traceroute.fontSize + 10,
              },
              ticks: {
                min: 0,
                fontSize: this.$store.state.textFormatting.chart.axis_label,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString:
                  "Hijack                                                                          Impact",
                fontSize:
                  this.$store.state.textFormatting.traceroute.fontSize + 10,
              },
              ticks: {
                display: false,
                fontSize: this.$store.state.textFormatting.chart.axis_label,
              },
            },
          ],
        },
      },
      tr_ip: "",
      tr_parentPrefix: "",
      tr_asn: "",
      tr_asowner: "",
      tr_title: "Pulling traceroute...",
      tr_result_1: {},
      tr_result_2: {},
      tr_result_man: {},
      tr_ts_1: null,
      tr_ts_2: null,
      tr_ts_man: null,
      tr_reformatted_1: {},
      tr_reformatted_2: {},
      tr_reformatted_man: {},
      tr_show_panel: true,
      tr_show_card: false,
      tr_loading: false,
      tr_click_enabled: false,
      tr_show_results: true,
      tr_keys: [],
      tr_nodes_1: [],
      tr_links_1: [],
      tr_table_1: [],
      tr_nodes_2: [],
      tr_links_2: [],
      tr_table_2: [],
      tr_nodes_man: [],
      tr_links_man: [],
      tr_table_man: [],
      tr_table_select: 1,
      tr_table_select_1: true,
      tr_table_select_2: false,
      tr_table_select_man: false,
      tr_table_select_1_colour: 'accent',
      tr_table_select_2_colour: 'white',
      tr_table_select_man_colour: 'white',
      tr_key_select: "",
      tr_options: {
        force: 1300,
        forces: {
          Center: true,
          X: this.$store.state.textFormatting.traceroute.s_x,
          Y: this.$store.state.textFormatting.traceroute.s_y,
          ManyBody: true,
          Link: true,
        },
        size: {
          w: this.$store.state.textFormatting.traceroute.width,
          h: this.$store.state.textFormatting.traceroute.s_height,
        },
        nodeSize: 20,
        nodeLabels: true,
        linkLabels: false,
        canvas: false,
        fontSize: this.$store.state.textFormatting.traceroute.fontSize,
      },
      tr_pagination: {
        rowsPerPage: 10,
      },
      tr_headers: [
        {
          text: "TTL/ Hop",
          value: "TTL",
          align: "centre",
          ad_text:
            "Number of hop in the traceroute (beginning at AWS datacentre, ending at destination)",
        },
        {
          text: "IP Address",
          value: "ip_address",
          align: "centre",
          ad_text: "IP Address for this hop",
        },
        {
          text: "ASN",
          value: "asn",
          align: "centre",
          ad_text: "ASN for this IP hop",
        },
        {
          text: "Time (ms)",
          value: "time",
          align: "centre",
          ad_text:
            "Time taken to reach this hop in the parallel traceroute (see info. box for detailed explanation)",
        },
      ],
      tr_all_nodes_1: [],
      tr_all_links_1: [],
      tr_all_nodes_2: [],
      tr_all_links_2: [],
      tr_all_nodes_man: [],
      tr_all_links_man: [],
      tr_show_all_1: false,
      tr_show_all_2: false,
      tr_all_color: "white",
      tr_all_options_1: {
        force: 500,
        forces: {
          Center: true,
          X: this.$store.state.textFormatting.traceroute.a_x,
          Y: this.$store.state.textFormatting.traceroute.a_y,
          ManyBody: true,
          Link: true,
        },
        size: {
          w: this.$store.state.textFormatting.traceroute.width,
          h: this.$store.state.textFormatting.traceroute.a_height,
        },
        nodeSize: 14,
        nodeLabels: true,
        linkLabels: true,
        canvas: false,
        fontSize: this.$store.state.textFormatting.traceroute.fontSize,
      },
      tr_all_options_2: {
        force: 500,
        forces: {
          Center: true,
          X: this.$store.state.textFormatting.traceroute.a_x,
          Y: this.$store.state.textFormatting.traceroute.a_y,
          ManyBody: true,
          Link: true,
        },
        size: {
          w: this.$store.state.textFormatting.traceroute.width,
          h: this.$store.state.textFormatting.traceroute.a_height,
        },
        nodeSize: 14,
        nodeLabels: true,
        linkLabels: true,
        canvas: false,
        fontSize: this.$store.state.textFormatting.traceroute.fontSize,
      },
      tr_full_download: [],
      mult_all_episodes: [],
      mult_tally: [],
      mult_show: false,
      mult_loading: false,
      mult_show_banner: true,
      mult_show_all: false,
      mult_title: "Loading recent alerts...",
      mult_sum_headers: [
        {
          text: "Prefix",
          ad_text: "The prefix of interest",
          value: "prefix",
          align: "centre",
        },
        {
          text: "Asserting Own.",
          ad_text: "Where this ASN is asserting ownership over another",
          value: "asserting_over",
          align: "centre",
        },
        {
          text: "Asserted Own.",
          ad_text:
            "Where this ASN has had another ASN asserting ownership over it",
          value: "asserted_over",
          align: "centre",
        },
        {
          text: "Path Change",
          ad_text:
            "Where the alert has the same ownership ASN pre/post occurance",
          value: "path_change",
          align: "centre",
        },
        {
          text: "First Seen",
          ad_text:
            "Where the alert was the first seen message of this prefix, from the given peer",
          value: "first_seen",
          align: "centre",
        },
      ],
      mult_enable: true,
      mult_message: false,
      mult_msg_colour: "success",
      mult_msg_tooltip: false,
      showBar: true,
      asn_own_dict: {},
      asn_get_owner: [],
      is_asn_owners: {
        main: false,
        similar: false,
        multiple: false,
        event: false,
      },
      org_impact: 0,
      user_impact: 0,
      event_indirect: false, // used for sub/super o.as.
      event_indirect_prefix: false, // used for sub/super o.as.
      checker_local: false,
      tr_2_interval: null,
      advanced_fields: true,
      disag_prefixes: [],
      disag_events: [],
      awaited: 0,
      send_disag: false,
      dummy: false
    };
  },
  beforeMount() {
    let app = findParentComponentByName(this, "app");
    app.checkSignedIn();
    this.invalidRequest=false;

    if (window.location.origin.includes("http://localhost")) {
      this.checker_local = true;
    }
    try {
//      console.log(this.$route.params)
      this.paramsCombined = this.$route.params.prefix;
      var spl = this.paramsCombined.split("~")
//      console.log(spl)
      if (spl.length > 4) {
        if (spl[4]=="D") {
//          console.log("IS DUMMY")
          this.dummy = true
        }
      }
//      console.log(this.paramsCombined);
//      console.log(spl)
    } catch (err) {
      console.log(err);
    }
    this.organisation = this.$store.state.user.organisation;
    this.user = this.$store.state.user.username;
    this.checkEpisodeInfoIsInGoodKnick(this.paramsCombined)
    this.advanced_fields = this.$store.state.showSettings.clickthroughAdvFields;
    this.advancedChange();
      // this.getScoredEpisodeFromURLParams(this.paramsCombined)

  },
  mounted() {
    this.getTraceroute(1);
  },
  methods: {
    routeNewWindow: async function (input) {
      //console.log(input);
      if (input == "Request Raw Data") {
        //console.log("ROUTING WITH ASN");
        this.$store.commit("setSearch", {
          rawASN: this.currentEpisodeData[0].origin_asn_new,
        });
        let routeData = this.$router.resolve({ name: input });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({ name: input });
        window.open(routeData.href, "_blank");
      }
    },
    advancedChange: async function () {
      if (this.advanced_fields) {
        this.headersEvent = [
          { text: "Event Type", value: "ev_type", align: "centre" },

          {
            text: "Exact Time",
            value: "exact_time",
            ad_text: "Exact time this event occurred",
            align: "centre",
          },

          {
            text: "Peer ASN (IP)",
            value: "peer_asn",
            ad_text:
              "ASN where this advertisment was seen from (the IP address)",
            align: "centre",
          },

          {
            text: "Old ASN Path",
            value: "path_old",
            ad_text: "AS path prior to this event occuring",
            align: "centre",
          },
          {
            text: "New ASN Path",
            value: "path_new",
            ad_text: "AS path after this event occurring",
            align: "centre",
          },
          {
            text: "Hijack Score",
            value: "hijack_score",
            ad_text:
              "How likely the system deems this to be a hijacking event (0 [unlikely] to 99 [very likely])",
            align: "centre",
          },
          {
            text: "Impact Score",
            value: "impact_score",
            ad_text:
              "If this were to be a hijacking event, how impactful would this be to the organisation(s) involved (can be set for 'Restricted Prefixes')",
            align: "centre",
          },
          {
            text: "Repeat Event Count",
            value: "event_count",
            ad_text:
              "How many occurances of this exact event happened in the 5 minute window",
            align: "centre",
          },
          {
            text: "Hijack Scope",
            value: "hijack_scope",
            ad_text:
              "The difference in CIDR of the episode prefix and the prefix having ownership asserted over e.g. if a /24 prefix advertisment occurs, but a /20 prefix is present in the system, the scope will be 4. The scope would be -4 if the prefixes were the other way round. NOTE: If restricted DNS has been hit, this will be the prefix used.",
            align: "centre",
          },
          {
            text: "Hijack Subtype",
            value: "hijack_subtype",
            ad_text:
              "Full: this ownership assertion has not been seen by the system before, Observed: this ownership assertion HAS been seen before, null: not an ownership assertion",
            align: "centre",
          },
          {
            text: "Restricted Prefix",
            value: "controlled_pre_show",
            ad_text:
              "If there's any organisation/ user restricted prefix that has been 'hit' by this event",
            align: "centre",
            sortable: false,
          },
          {
            text: "Edit Distance",
            value: "edit_distance",
            ad_text:
              "The amount of changes (insertion/ replacement/ deletion) to get from the old AS path to the new AS path (accounting for duplicates)",
            align: "centre",
          },
          {
            text: "Path Change Type",
            value: "pathchange_type",
            ad_text: "see. glossary for explanation",
            align: "centre",
          },
          {
            text: "AS Common Owner",
            value: "common_owner",
            ad_text: "If we have a common owner of the new and old ASN, following possibilities: missing - one or more of the ASNs has no ownership, possible - matched but not definite, definite - guaranteed common ownership.",
            align: "centre",
          },
          {
            text: "ASN Geocomparison",
            value: "asn_geocomparison",
            ad_text:
              "Correlation of the old/ new origin ASNs (0 [no correlation] to 1 [perfect correlation])",
            align: "centre",
          },
          {
            text: "Prefix vs ASN Geo",
            value: "prefix_vs_asn_geo",
            ad_text:
              "Correlation of the prefix and new origin ASN (0 [no correlation] to 1 [perfect correlation])",
            align: "centre",
          },
          {
            text: "Bogon",
            value: "bogon",
            ad_text: "If we have a bogon hit, displays here",
            align: "centre",
          },
          {
            text: "Route Leak",
            value: "route_leak_flag",
            ad_text: "1 if route leak (see glossary.), 0 if not a route leak",
            align: "centre",
          },
          {
            text: "Restricted DNS",
            value: "restricted_dns",
            ad_text: "If we have a restricted DNS hit, displays here",
            align: "centre",
            sortable: false,
          },
          /*{
            text: "Registrar Flag",
            value: "registrar_flag",
            ad_text: '0 if prefix is permitted to advertise this prefix, 1 if not',
            align: "centre"
          }*/
        ];
      } else {
        this.headersEvent = [
          { text: "Event Type", value: "ev_type", align: "centre" },

          {
            text: "Exact Time",
            value: "exact_time",
            ad_text: "Exact time this event occurred",
            align: "centre",
          },

          {
            text: "Peer ASN (IP)",
            value: "peer_asn",
            ad_text:
              "ASN where this advertisment was seen from (the IP address)",
            align: "centre",
          },

          {
            text: "Old ASN Path",
            value: "path_old",
            ad_text: "AS path prior to this event occuring",
            align: "centre",
          },
          {
            text: "New ASN Path",
            value: "path_new",
            ad_text: "AS path after this event occurring",
            align: "centre",
            sortable: false,
          },
          {
            text: "Hijack Score",
            value: "hijack_score",
            ad_text:
              "How likely the system deems this to be a hijacking event (0 [unlikely] to 99 [very likely])",
            align: "centre",
          },
          {
            text: "Impact Score",
            value: "impact_score",
            ad_text:
              "If this were to be a hijacking event, how impactful would this be to the organisation(s) involved (can be set for 'Restricted Prefixes')",
            align: "centre",
          },
          /*{
            text: "Repeat Event Count",
            value: "event_count",
            ad_text: 'How many occurances of this exact event happened in the 5 minute window',
            align: "centre"
          },
          {
            text: "Hijack Scope",
            value: "hijack_scope",
            ad_text: 'The difference in CIDR of the episode prefix and the prefix having ownership asserted over e.g. if a /24 prefix advertisment occurs, but a /20 prefix is present in the system, the scope will be 4. The scope would be -4 if the prefixes were the other way round',
            align: "centre"
          },
          {
            text: "Hijack Subtype",
            value: "hijack_subtype",
            ad_text: 'Full: this ownership assertion has not been seen by the system before, Observed: this ownership assertion HAS been seen before, null: not an ownership assertion',
            align: "centre"
          },
          {
            text: "Restricted Prefix",
            value: "controlled_pre_show",
            ad_text: 'If there\'s any organisation/ user restricted prefix that has been \'hit\' by this event',
            align: "centre",
            sortable: false
          },
          {
            text: "Edit Distance",
            value: "edit_distance",
            ad_text: 'The amount of changes (insertion/ replacement/ deletion) to get from the old AS path to the new AS path (accounting for duplicates)',
            align: "centre"
          },
          {
            text: "Path Change Type",
            value: "pathchange_type",
            ad_text: 'see. glossary for explanation',
            align: "centre"
          },
          {
            text: "ASN Geocomparison",
            value: "asn_geocomparison",
            ad_text: 'Correlation of the old/ new origin ASNs (0 [no correlation] to 1 [perfect correlation])',
            align: "centre"
          },
          {
            text: "Prefix vs ASN Geo",
            value: "prefix_vs_asn_geo",
            ad_text: 'Correlation of the prefix and new origin ASN (0 [no correlation] to 1 [perfect correlation])',
            align: "centre"
          },
          { 
            text: "Bogon", 
            value: "bogon", 
            ad_text: 'If we have a bogon hit, displays here',
            align: "centre" 
          },
          {
            text: "Route Leak",
            value: "route_leak_flag",
            ad_text: '1 if route leak (see glossary.), 0 if not a route leak',
            align: "centre"
          },
          {
            text: "Restricted DNS",
            value: "restricted_dns",
            ad_text: 'If we have a restricted DNS hit, displays here',
            align: "centre",
            sortable: false
          },
          {
            text: "Registrar Flag",
            value: "registrar_flag",
            ad_text: '0 if prefix is permitted to advertise this prefix, 1 if not',
            align: "centre"
          }*/
        ];
      }
      if (this.event_indirect) {
        this.headersEvent[2] = {
          ad_text:
            "Non-direct ASN refers to the authorative owner of either the parent or child prefix in this event.\n In this case there will be no 'old path' as we are basing the ownership assertion on reference data of the parent/ child.\n The non-direct ASN type is either authorative (i.e. from reference data) or observed (i.e. from live data).",
          align: "centre",
          text: "Non-direct ASN type",
          value: "non_direct_asn_type",
        };
      }
      if (this.event_indirect_prefix) {
        this.headersEvent.splice(3, 0, {
          ad_text:
            "Non-direct prefix is the prefix of the parent/ child having sub/ super ownership asserted over",
          align: "centre",
          text: "Non-direct Prefix",
          value: "non_direct_prefix",
        });
      }
    },
    refreshSecond: async function () {
      clearInterval(this.tr_2_interval);
      this.tr_show_all_1 = false;
      this.tr_show_all_2 = false;
      this.$nextTick(() => {
        // Add the component back in
        this.tr_show_all_2 = true;
        this.tr_show_all_1 = true;
      });
    },
    refreshFirst: async function () {
      clearInterval(this.tr_2_interval);
      this.tr_show_all_1 = false;
      this.tr_show_all_2 = false;
      this.$nextTick(() => {
        // Add the component back in
        this.tr_show_all_1 = true;
        this.tr_2_interval = setInterval(() => {
          this.tr_show_all_2 = true;
        }, 2);
      });
    },
    set_tr_table_select: async function (tablenum) {
      this.tr_table_select_1=false
      this.tr_table_select_2=false
      this.tr_table_select_man=false
      this.tr_table_select_1_colour="white"
      this.tr_table_select_2_colour="white"
      this.tr_table_select_man_colour="white"
      if (tablenum==1) {
        this.tr_table_select_1=true
        this.tr_table_select_1_colour="accent"
      }
      if (tablenum==2) {
        this.tr_table_select_2=true
        this.tr_table_select_2_colour="accent"
      }
      if (tablenum==3) {
        this.tr_table_select_man=true
        this.tr_table_select_man_colour="accent"
      }
      this.tr_table_select=tablenum;
    },
    triggerRefreshManTraceRoute: async function() {
      this.tr_loading=true
      if (this.manTrQueued) {
        this.getManTraceroute(this.notification_id)
      }
      if (this.manTrRun) {
        clearInterval(this.manTrTimer)
        this.reformatTr(3)
      }
      this.tr_loading=false
    },
    nodeClick: async function (event,node) {
      this.showNodeDetails=true
      this.tr_asn=node.asn;
      this.tr_ip=node.ip_addr;
      this.tr_asowner="N/A";
      this.tr_parentPrefix=node.parent;
      if (node.asnumber>0){
        this.tr_asowner=await this.getAnASNOwner(node.asnumber)
      }
      //console.log(event);
      //console.log(node);
    },
    switchTrIpAsn: async function () {
      this.showTrASNs=!this.showTrASNs
      var key=this.tr_key_select
      this.rewriteTr(1)
      this.rewriteTr(2)
      this.rewriteTr(3)
    },
    selectTrSource: async function (name) {
      this.showNodeDetails=false
      //console.log("selecting tr source: " + name);
      clearInterval(this.tr_2_interval);
      for (var i = 0; i < this.tr_keys.length; i++) {
        if (this.tr_keys[i]["name"] == name) {
          this.tr_show_all_1 = false;
          this.tr_show_all_2 = false;
          this.tr_keys[i]["color"] = "accent";
          this.tr_key_select = name;
          this.tr_title = "Traceroute results: " + this.tr_key_select;
          this.tr_nodes_1 = this.tr_reformatted_1[name]["nodes"];
          this.tr_table_1 = this.tr_reformatted_1[name]["table"];
          this.tr_links_1 = this.tr_reformatted_1[name]["links"];
          this.tr_nodes_2 = this.tr_reformatted_2[name]["nodes"];
          this.tr_table_2 = this.tr_reformatted_2[name]["table"];
          this.tr_links_2 = this.tr_reformatted_2[name]["links"];
          if (this.manTrRun) {
            this.tr_nodes_man = this.tr_reformatted_man[name]["nodes"];
            this.tr_table_man = this.tr_reformatted_man[name]["table"];
            this.tr_links_man = this.tr_reformatted_man[name]["links"];
          }
        } else {
          this.tr_keys[i]["color"] = "white";
        }
      }
      if (name == "All") {
        this.tr_show_all_1 = false;
        this.tr_show_all_2 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.tr_show_all_2 = true;
          this.tr_show_all_1 = true;
        });

        this.tr_all_color = "accent";
      } else {
        this.tr_show_all_1 = false;
        this.tr_show_all_2 = false;
        this.tr_all_color = "white";
      }
    },
    flipTr: async function () {
      if (this.tr_click_enabled) {
        if (this.tr_show_card == false) {
          this.tr_title = "Traceroute results: " + this.tr_key_select;
          this.tr_show_card = true;
          this.tr_show_all_1 = true;
          this.tr_show_all_2 = true;
          this.$nextTick(() => {
            // Add the component back in
            this.tr_show_all_1 = false;
            this.tr_show_all_2 = false;
          });
        } else {
          this.tr_title = "Traceroute results";
          this.tr_show_card = false;
        }
      } else {
        if (this.tr_loading == false) {
          this.tr_show_panel = false;
        }
      }
    },
    rewriteTr: async function (type){
      var nodes,tr
      if (type == 1) {
        tr = this.tr_reformatted_1;
        nodes = this.tr_nodes_1;
      } else if (type == 2) {
        tr = this.tr_reformatted_2;
        nodes = this.tr_nodes_2;
      } else if (type == 3) {
        tr = this.tr_reformatted_man;
        nodes = this.tr_nodes_man;
      }
      
      var tr_sources = Object.keys(tr);
      var relabel,i,k
      for (i = 0; i < tr_sources.length; i++) {
        relabel=tr[tr_sources[i]]["nodes"]
        for (k=0; k < relabel.length; k++) {
          if (this.showTrASNs) {
            relabel[k]["name"]=relabel[k]["asname"]
            relabel[k]["_color"]=relabel[k]["asn_color"]
            if (relabel[k]["asn_size"]>0) {
              relabel[k]["_size"]=relabel[k]["asn_size"]
            }
          } else {
            relabel[k]["name"]=relabel[k]["ipname"]
            relabel[k]["_color"]=relabel[k]["ip_color"]
            delete relabel[k]["_size"]
          }
        }
        if (type==1){
          this.tr_reformatted_1[tr_sources[i]]["nodes"]=relabel
        } else if (type == 2) {
          this.tr_reformatted_2[tr_sources[i]]["nodes"]=relabel
        } else if (type == 3) {
          this.tr_reformatted_man[tr_sources[i]]["nodes"]=relabel
        }
        for (k=0; k < nodes.length; k++) {
          if (this.showTrASNs) {
            nodes[k]["name"]=nodes[k]["asname"]
          } else {
            nodes[k]["name"]=nodes[k]["ipname"]
          }
        }
        if (tr_sources[i] == this.tr_key_select) {
          if (type == 1) {
            this.tr_nodes_1 = nodes;
          } else if (type==2) {
            this.tr_nodes_2 = nodes;
          } else if (type==3) {
            this.tr_nodes_man = nodes;
          }
        }
      }

      if (type == 1) {
        nodes = this.tr_all_nodes_1;
      } else if (type == 2) {
        nodes = this.tr_all_nodes_2;
      } else if (type == 3) {
        nodes = this.tr_all_nodes_man;
      }
      
      for (k=0; k < nodes.length; k++) {
        if (this.showTrASNs) {
          nodes[k]["name"]=nodes[k]["asname"]
          nodes[k]["_color"]=nodes[k]["asn_color"]
          if (nodes[k]["asn_size"]>0) {
            nodes[k]["_size"]=nodes[k]["asn_size"]
          }
        } else {
          nodes[k]["name"]=nodes[k]["ipname"]
          nodes[k]["_color"]=nodes[k]["ip_color"]
          delete nodes[k]["_size"]
        }
      }
      if (type==1){
        this.tr_all_nodes_1=nodes
      } else if (type==2) {
        this.tr_all_nodes_2=nodes
      } else if (type==3) {
        this.tr_all_nodes_man=nodes
      }

    },
    reformatTr: async function (type) {
      this.tr_keys = [];
      if (type == 1) {
        this.tr_reformatted_1 = {};
        var tr = this.tr_result_1;
      } else if (type == 2) {
        this.tr_reformatted_2 = {};
        var tr = this.tr_result_2;
      } else if (type == 3) {
        this.tr_reformatted_man = {};
        var tr = this.tr_result_man;
      }

      //console.log(tr)
      var tr_sources = Object.keys(tr);
      var tr_keys = [];
      //console.log("TR SOURCES")
      //console.log(tr_sources)
      var tr_reformatted = {};
      for (var i = 0; i < tr_sources.length; i++) {
        if (i == 0) {
          this.tr_key_select = tr_sources[i];
          tr_keys.push({
            name: tr_sources[i],
            color: "accent",
          });
        } else {
          tr_keys.push({
            name: tr_sources[i],
            color: "white",
          });
        }

        var tr_dict = tr[tr_sources[i]];
        var tbl = this.makeTrTable(tr_dict);
        //console.log(tbl);
        for (var k = 0; k < tbl.length; k++) {
          try {
            this.tr_full_download.push({
              ttl: tbl[k]["TTL"],
              asn: tbl[k]["asn"],
              ip_address: tbl[k]["ip_address"],
              time: tbl[k]["time"],
              source: tr_sources[i],
              tr_1_or_2: type,
            });
          } catch (err) {
            console.log(err);
          }
        }
        var nodes = this.makeTrNodes(tr_dict, type, tr_sources[i]);
        var links = this.makeTrLinks(tr_dict);
        this.addCombNodes(tr_sources[i], tr_dict, i, type);
        tr_reformatted[tr_sources[i]] = {
          table: tbl,
          nodes: nodes,
          links: links,
        };
        if (i == tr_sources.length - 1) {
          this.tr_keys = tr_keys;
          this.makeCombLinks(type);

          if (type == 1) {
            this.tr_reformatted_1 = tr_reformatted;
            this.getTraceroute(2);
          } else if (type == 2) {
            this.tr_reformatted_2 = tr_reformatted;
          } else if (type == 3) {
            this.tr_reformatted_man = tr_reformatted;
          }
          this.tr_click_enabled = true;
          this.tr_title = "Traceroute results";
          this.tr_loading = false;
        }
        if (i == 0) {
          if (type == 1) {
            this.tr_nodes_1 = nodes;
            this.tr_table_1 = tbl;
            this.tr_links_1 = links;
          } else if (type == 2) {
            this.tr_nodes_2 = nodes;
            this.tr_table_2 = tbl;
            this.tr_links_2 = links;
          } else if (type == 3) {
            this.tr_nodes_man = nodes;
            this.tr_table_man = tbl;
            this.tr_links_man = links;
          }
        }
      }
    },
    addCombNodes: async function (src, tr_dict, layer, type) {
      //this.tr_all_nodes_1
      //this.tr_all_links_1
      //console.log("LAYER: " + layer.toString())
      if (type == 3) {
        return
      }
      if (type == 2) {
        var st_node = 1000;
      } else {
        var st_node = 0;
      }
      if (type == 1) {
        for (var j = 0; j < this.tr_all_nodes_1.length; j++) {
          if (this.tr_all_nodes_1[j]["id"] > st_node) {
            st_node = this.tr_all_nodes_1[j]["id"];
          }
        }
      } else {
        for (var j = 0; j < this.tr_all_nodes_2.length; j++) {
          if (this.tr_all_nodes_2[j]["id"] > st_node) {
            st_node = this.tr_all_nodes_2[j]["id"];
          }
        }
      }
      var hops = Object.keys(tr_dict);
      for (var i = 0; i < hops.length; i++) {
        if (!tr_dict[hops[i]]["source"] && i != hops.length - 1) {
          hops.splice(i, 1);
          i -= 1;
        } else {
          hops[i] = parseInt(hops[i]);
          //console.log(tr_dict[hops[i]])
        }
      }

      var mink = Math.min(...hops);
      var maxk = Math.max(...hops);
      var asn=''
      for (var i = 0; i < hops.length; i++) {
        var thisnode = st_node + 1 + i;
        var node = {};
        if ("parent" in tr_dict[hops[i]]) {
          if (tr_dict[hops[i]]["parent"] !=null) {
            node["parent"]=tr_dict[hops[i]]["parent"].toString();
          } else {
            node["parent"]=" - "
          }
        } else {
          node["parent"]=" - "
        }
        asn=tr_dict[hops[i]]["asn"].toString();
        node["asnumber"]= asn;
        node["asn"]=asn
        if (asn=='AS0') {
          asn='unknown';
          node["asnumber"]= 0;
        } else if (asn.includes('Shared')){
          asn='shared'
          node["asnumber"]= 0;
        } else if (asn.includes('Reserved')){
          asn='reserved'
          node["asnumber"]= 0;
        } else {
          asn="AS" + tr_dict[hops[i]]["asn"].toString();
          node["asn"]=asn
        }


        if (hops[i] == mink) {
          node["_color"] = "green";
          node["name"] = src + ": " + tr_dict[hops[i]]["source"];
          node["asname"] = src + ": " + asn
        } else if (hops[i] == maxk) {
          node["_color"] = "gold";
          if (tr_dict[hops[i]]["source"]) {
            node["name"] = "DEST: " + tr_dict[hops[i]]["source"];
            node["asname"] = "DEST: " + ": " + asn
          } else {
            node["name"] = "DEST: ***";
            node["asname"] = "DEST: ***";
          }
        } else {
          if (type == 1) {
            node["_color"] = "blue";
            node["name"] = tr_dict[hops[i]]["source"];
            node["asname"] = asn
          } else {
            // WORK HERE
            node["_color"] = "blue";
            node["name"] = tr_dict[hops[i]]["source"];
            node["asname"] = asn
          }
        }
        node["ipname"] = node["name"];
        node["d_from_src"] = i;
        node["layer"] = layer;
        node["d_total"] = hops.length - 1;
        node["id"] = thisnode;
        node["inc_conn"] = 1;

        node["asn_size"]=0
        node["asn_color"]=node["_color"]
        node["ip_color"]=node["_color"]
        if (asn=='AS0') {
          if ((i+1) < hops.length){
            node["asn_color"]="grey";
            node["asn_size"]=10;
          }
        }
        if (asn.includes('shared')){
          node["asn_color"]="grey";
          node["asn_size"]=10;
        } 
        if (asn.includes('reserved')){
          node["asn_color"]="grey";
          node["asn_size"]=10;
        }

        if (tr_dict[hops[i]]["source"]) {
          node["ip_addr"] = tr_dict[hops[i]]["source"];
        } else {
          node["ip_addr"] = "***";
        }
        //console.log(i.toString() + " and total hops is " + (hops.length - 1 ).toString())
        if (i < hops.length - 1) {
          var k = 1;
          while (i + k < hops.length) {
            //console.log(hops[i].toString() + " looking for hop " + hops[i+k].toString())
            //console.log("DEBUGGING: " + tr_dict[hops[i+k]]['source'])

            if (tr_dict[hops[i + k]]["source"] == node["ip_addr"]) {
              k += 1;
            } else {
              if (tr_dict[hops[i + k]]["source"]) {
                node["downstream"] = tr_dict[hops[i + k]]["source"];
              } else {
                node["downstream"] = "***";
              }
              break;
            }
          }
          if (hops[i + k] - hops[i] > 1) {
            node["ds_type"] = "dashed";
          } else {
            node["ds_type"] = "flat";
          }
        }

        var found = 0;
        if (type == 1) {
          for (var j = 0; j < this.tr_all_nodes_1.length; j++) {
            if (node["ip_addr"] == this.tr_all_nodes_1[j]["ip_addr"]) {
              found = 1;

              if (node["downstream"] != this.tr_all_nodes_1[j]["downstream"]) {
                this.tr_all_nodes_1[j]["downstream"] += ",";
                this.tr_all_nodes_1[j]["downstream"] += node["downstream"];
                //console.log("THIS IS NOT A DRILL");
                //console.log(node["downstream"]);
                //console.log(this.tr_all_nodes_1[j]["downstream"]);
              } else {
                this.tr_all_nodes_1[j]["inc_conn"] += 1;
              }
            }
          }
          //console.log(node)
          //console.log(found)
          if (found == 0) {
            this.tr_all_nodes_1.push(node);
          }
        } else {
          for (var j = 0; j < this.tr_all_nodes_2.length; j++) {
            if (node["ip_addr"] == this.tr_all_nodes_2[j]["ip_addr"]) {
              found = 1;

              if (node["downstream"] != this.tr_all_nodes_2[j]["downstream"]) {
                this.tr_all_nodes_2[j]["downstream"] += ",";
                this.tr_all_nodes_2[j]["downstream"] += node["downstream"];
                //console.log("THIS IS NOT A DRILL");
                //console.log(node["downstream"]);
                //console.log(this.tr_all_nodes_2[j]["downstream"]);
              } else {
                this.tr_all_nodes_2[j]["inc_conn"] += 1;
              }
            }
          }
          //console.log(node)
          //console.log(found)
          if (found == 0) {
            this.tr_all_nodes_2.push(node);
          }
        }
      }
    },
    makeCombLinks: function (type) {
      // NOTE: Also sets the x and y co-ordinates of the nodes
      if (type == 1) {
        var st_index = 0;
        for (var i = 0; i < this.tr_all_nodes_1.length; i++) {
          var node_use = this.tr_all_nodes_1[i];
          if (node_use["downstream"]) {
            var ip_hunt = node_use["downstream"];
            //console.log("IPHUNT")
            //console.log(ip_hunt)
            if (ip_hunt.includes(",")) {
              var ips_hunt = ip_hunt.split(",");
              for (var k = 0; k < ips_hunt.length; k++) {
                var t_id = null;
                var to_hunt = ips_hunt[k];
                //console.log("TOHUNT")
                //console.log(to_hunt)
                for (var j = 0; j < this.tr_all_nodes_1.length; j++) {
                  if (this.tr_all_nodes_1[j]["ip_addr"] == to_hunt) {
                    t_id = this.tr_all_nodes_1[j]["id"];
                  }
                }
                if (type == 1) {
                  var bonuslink = 200;
                } else {
                  var bonuslink = 0;
                }

                if (node_use["ds_type"] == "dashed") {
                  var svg_attrs = {
                    "stroke-dasharray":
                      (6 * node_use["inc_conn"]).toString() +
                      " " +
                      (6 * node_use["inc_conn"]).toString(),
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "red",
                  };
                } else {
                  var svg_attrs = {
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "red",
                  };
                }
                this.tr_all_links_1.push({
                  sid: node_use["id"],
                  tid: t_id,
                  _svgAttrs: svg_attrs,
                });
                st_index += 1;
              }
            } else {
              var t_id = null;
              for (var j = 0; j < this.tr_all_nodes_1.length; j++) {
                if (this.tr_all_nodes_1[j]["ip_addr"] == ip_hunt) {
                  t_id = this.tr_all_nodes_1[j]["id"];
                }
              }
              if (type == 1) {
                var bonuslink = 200;
              } else {
                var bonuslink = 0;
              }
              if (node_use["downstream"]) {
                if (node_use["ds_type"] == "dashed") {
                  var svg_attrs = {
                    "stroke-dasharray":
                      (6 * node_use["inc_conn"]).toString() +
                      " " +
                      (6 * node_use["inc_conn"]).toString(),
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "red",
                  };
                } else {
                  var svg_attrs = {
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "red",
                  };
                }
                this.tr_all_links_1.push({
                  sid: node_use["id"],
                  tid: t_id,
                  _svgAttrs: svg_attrs,
                });
                st_index += 1;
              }
            }
          }

          //console.log(node_use['layer'] / (this.tr_keys.length - 1))
          //console.log(Math.PI / 2)
          //console.log(Math.sin(node_use['layer'] * Math.PI / (2 * (this.tr_keys.length - 1))))
          var angle_use; // we add this part in to account for labelling
          if (node_use["layer"] * 2 >= this.tr_keys.length - 1) {
            angle_use =
              3 / 4 +
              (11 / 20) *
                (node_use["layer"] / (this.tr_keys.length - 1) - 3 / 4);
          } else {
            angle_use =
              1 / 4 +
              (11 / 20) *
                (node_use["layer"] / (this.tr_keys.length - 1) - 1 / 4);
          }
          this.tr_all_nodes_1[i]["x"] =
            400 -
            Math.cos(angle_use * 2 * Math.PI) *
              350 *
              (1 - node_use["d_from_src"] / node_use["d_total"]);
          this.tr_all_nodes_1[i]["y"] =
            250 -
            Math.sin(angle_use * 2 * Math.PI) *
              225 *
              (1 - node_use["d_from_src"] / node_use["d_total"]);
        }
      } else {
        for (var i = 0; i < this.tr_all_nodes_2.length; i++) {
          var node_use = this.tr_all_nodes_2[i];
          if (node_use["downstream"]) {
            var ip_hunt = node_use["downstream"];
            //console.log("IPHUNT")
            //console.log(ip_hunt)
            if (ip_hunt.includes(",")) {
              var ips_hunt = ip_hunt.split(",");
              //console.log("IPSHUNT")
              //console.log(ips_hunt)

              for (var k = 0; k < ips_hunt.length; k++) {
                var t_id = null;
                var to_hunt = ips_hunt[k];
                //console.log("TOHUNT")
                //console.log(to_hunt)
                for (var j = 0; j < this.tr_all_nodes_2.length; j++) {
                  if (this.tr_all_nodes_2[j]["ip_addr"] == to_hunt) {
                    t_id = this.tr_all_nodes_2[j]["id"];
                  }
                }
                if (t_id == null) {
                  continue;
                }

                if (node_use["ds_type"] == "dashed") {
                  var svg_attrs = {
                    "stroke-dasharray":
                      (6 * node_use["inc_conn"]).toString() +
                      " " +
                      (6 * node_use["inc_conn"]).toString(),
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "black",
                  };
                } else {
                  var svg_attrs = {
                    "stroke-width": 3 * node_use["inc_conn"],
                    stroke: "black",
                  };
                }
                this.tr_all_links_2.push({
                  sid: node_use["id"],
                  tid: t_id,
                  _svgAttrs: svg_attrs,
                });
              }
            } else {
              var t_id = null;
              for (var j = 0; j < this.tr_all_nodes_2.length; j++) {
                if (this.tr_all_nodes_2[j]["ip_addr"] == ip_hunt) {
                  t_id = this.tr_all_nodes_2[j]["id"];
                }
              }
              if (t_id == null) {
                continue;
              }

              if (node_use["ds_type"] == "dashed") {
                var svg_attrs = {
                  "stroke-dasharray":
                    (6 * node_use["inc_conn"]).toString() +
                    " " +
                    (6 * node_use["inc_conn"]).toString(),
                  "stroke-width": 3 * node_use["inc_conn"],
                  stroke: "black",
                };
              } else {
                var svg_attrs = {
                  "stroke-width": 3 * node_use["inc_conn"],
                  stroke: "black",
                };
              }
              this.tr_all_links_2.push({
                sid: node_use["id"],
                tid: t_id,
                _svgAttrs: svg_attrs,
              });
            }
          }
          //console.log(node_use['layer'] / (this.tr_keys.length - 1))
          //console.log(Math.PI / 2)
          //console.log(Math.sin(node_use['layer'] * Math.PI / (2 * (this.tr_keys.length - 1))))
          var angle_use; // we add this part in to account for labelling
          if (node_use["layer"] * 2 >= this.tr_keys.length - 1) {
            angle_use =
              3 / 4 +
              (11 / 20) *
                (node_use["layer"] / (this.tr_keys.length - 1) - 3 / 4);
          } else {
            angle_use =
              1 / 4 +
              (11 / 20) *
                (node_use["layer"] / (this.tr_keys.length - 1) - 1 / 4);
          }
          this.tr_all_nodes_2[i]["x"] =
            400 -
            Math.cos(angle_use * 2 * Math.PI) *
              350 *
              (1 - node_use["d_from_src"] / node_use["d_total"]);
          this.tr_all_nodes_2[i]["y"] =
            250 -
            Math.sin(angle_use * 2 * Math.PI) *
              225 *
              (1 - node_use["d_from_src"] / node_use["d_total"]);
        }
      }
    },
    makeTrTable: function (tr_dict) {
      var rtrn = [];
      var hops = Object.keys(tr_dict);
      for (var i = 0; i < hops.length; i++) {
        if (tr_dict[hops[i]]["source"]) {
          rtrn.push({
            TTL: hops[i],
            ip_address: tr_dict[hops[i]]["source"],
            asn: tr_dict[hops[i]]["asn"],
            time: tr_dict[hops[i]]["time"],
          });
        } else {
          rtrn.push({
            TTL: hops[i],
            ip_address: "***",
            asn: "***",
            time: tr_dict[hops[i]]["time"],
          });
        }
      }
      return rtrn;
    },
    makeTrNodes: function (tr_dict, type, tr_src) {
      if (type == 2) {
        var iplist = [];
        var ip3list = [];
        let x = this.tr_reformatted_1[tr_src]["nodes"];
        for (var j = 0; j < x.length; j++) {
          iplist.push(x[j]["ip_addr"]);
          if (x[j]["ip_addr"].includes(":")) {
            var pos = x[j]["ip_addr"].lastIndexOf(":");
            var ip3 = x[j]["ip_addr"].substring(0, pos);
            ip3list.push(ip3);
          } else {
            var spl = x[j]["ip_addr"].split(".");
            ip3list.push(spl[0] + "." + spl[1] + "." + spl[2]);
          }
        }
      }
      if (type == 3) {
        var iplist = [];
        var ip3list = [];
        let x = this.tr_reformatted_2[tr_src]["nodes"];
        for (var j = 0; j < x.length; j++) {
          iplist.push(x[j]["ip_addr"]);
          if (x[j]["ip_addr"].includes(":")) {
            var pos = x[j]["ip_addr"].lastIndexOf(":");
            var ip3 = x[j]["ip_addr"].substring(0, pos);
            ip3list.push(ip3);
          } else {
            var spl = x[j]["ip_addr"].split(".");
            ip3list.push(spl[0] + "." + spl[1] + "." + spl[2]);
          }
        }
      }

      var rtrn = [];
      var hops = Object.keys(tr_dict);
      for (var i = 0; i < hops.length; i++) {
        if (!tr_dict[hops[i]]["source"] && i != hops.length - 1) {
          hops.splice(i, 1);
          i -= 1;
        } else {
          hops[i] = parseInt(hops[i]);
        }
      }
      var mink = Math.min(...hops);
      var maxk = Math.max(...hops);
      for (var i = 0; i < hops.length; i++) {
        var node = {};
        if (hops[i] == mink) {
          node["_color"] = "green";
        } else if (hops[i] == maxk) {
          node["_color"] = "gold";
        } else {
          if (type == 1) {
            node["_color"] = "blue";
          } else {
            //console.log(this.tr_reformatted_1)

            var tr1 = tr_dict[hops[i]]["source"];
            //console.log(tr1)
            if (tr1 in iplist) {
              node["_color"] = "blue";
            } else {
              if (tr1.includes(":")) {
                var pos = tr1.lastIndexOf(":");
                var tr1_3 = tr1.substring(0, pos);
                if (ip3list.includes(tr1_3)) {
                  node["_color"] = "blue";
                } else {
                  node["_color"] = "red";
                }
              } else {
                var tr1spl = tr1.split(".");
                var tr1_3 = tr1spl[0] + "." + tr1spl[1] + "." + tr1spl[2];
                //console.log(tr1_3)
                //console.log(ip3list)
                if (ip3list.includes(tr1_3)) {
                  node["_color"] = "blue";
                } else {
                  node["_color"] = "red";
                }
              }
            }

            //node['_color'] = 'magenta'
          }
        }
        node["id"] = i;
        node["x"] = 50 + 800 * (i / hops.length);
        node["y"] = 50 + (i % 3) * 150;
        var asn=''
        asn=tr_dict[hops[i]]["asn"].toString();
        node["asnumber"]= asn;
        node["asn"]=asn
        if ("parent" in tr_dict[hops[i]]) {
          if (tr_dict[hops[i]]["parent"] != null){
            node["parent"]=tr_dict[hops[i]]["parent"].toString();
          } else {
            node["parent"]=" - "
          }
        } else {
          node["parent"]=" - "
        }
        node["asn_size"]=0
        node["asn_color"]=node["_color"]
        node["ip_color"]=node["_color"]
        if (asn=='AS0') {
          asn='unknown';
          node["asnumber"]= 0;
          if ((i+1) < hops.length){
            node["asn_color"]="grey";
            node["asn_size"]=10;
          }
        }
        else if (asn.includes('Shared')){
          asn='shared'
          node["asnumber"]= 0;
          node["asn_color"]="grey";
          node["asn_size"]=10;
        } 
        else if (asn.includes('Reserved')){
          asn='reserved'
          node["asnumber"]= 0;
          node["asn_color"]="grey";
          node["asn_size"]=10;
        }
        else {
          asn="AS" + tr_dict[hops[i]]["asn"].toString();
          node["asn"]=asn
        }

        if (tr_dict[hops[i]]["source"]) {
          node["ipname"]=hops[i] + ": " + tr_dict[hops[i]]["source"];
          node["asname"]=hops[i] + ": " + asn;
          if (this.showTrASNs) {
            node["name"] = hops[i] + ": " + asn;
            node["_color"]=node["asn_color"];
          } else {
            node["name"] = hops[i] + ": " + tr_dict[hops[i]]["source"];
          }
          node["ip_addr"] = tr_dict[hops[i]]["source"];
        } else {
          node["name"] = "***";
          node["ip_addr"] = "";
          node["asname"] = "***";
          node["ipname"] = "***"
        }
        rtrn.push(node);
      }

      return rtrn;
    },
    makeTrLinks: function (tr_dict) {
      var rtrn = [];
      var hops = Object.keys(tr_dict);
      for (var i = 0; i < hops.length; i++) {
        if (!tr_dict[hops[i]]["source"] && i != hops.length - 1) {
          hops.splice(i, 1);
          i -= 1;
        } else {
          hops[i] = parseInt(hops[i]);
        }
      }
      for (var i = 0; i < hops.length - 1; i++) {
        if (hops[i + 1] - hops[i] > 1) {
          var link = {
            sid: i,
            tid: i + 1,
            _svgAttrs: {
              "stroke-dasharray": "4 4",
              "stroke-width": 2,
            },
          };
        } else {
          var link = {
            sid: i,
            tid: i + 1,
          };
        }
        rtrn.push(link);
      }
      return rtrn;
    },
    triggerManualTraceroute: async function() {
//      console.log("RUNNING TRIGGER MAN TR");
      this.tr_loading = true;
      var spl = this.paramsCombined.split("~");
      var pre = spl[0];
      var asn_old = spl[1];
      var asn_new = spl[2];
      var ts = spl[3];
      try {
        var trQueue =
          `mutation addManualTraceroute { addManualTraceroute(
            notification_id: ` + this.notification_id + `, 
            p_prefix: "` + pre + `", 
            p_asn_old: ` + asn_old + `, 
            p_asn_new: ` + asn_new + `, 
            p_time_5min: ` + ts + `
            ) { 
              response
              } 
            }`;
//        console.log(trQueue);
        const trTriggerResponse = await API.graphql(graphqlOperation(trQueue));
        if (!trTriggerResponse) {
          console("No response")
        } else {
          var tr = trTriggerResponse.data;          
//          console.log(trTriggerResponse)
          this.manTrQueued=true;
          this.manTrRun=false;
          this.manTrTimer = setInterval(this.triggerRefreshManTraceRoute, 1000);
        }
      } catch (err) {
        console.log("ERR")
        console.log(err);
      }
      this.tr_loading = false;
    },
    getManTraceroute: async function () {
      this.tr_loading = true;
      var spl = this.paramsCombined.split("~");
      var pre = spl[0];
      var ts = spl[3];
      try {
        var trQuery =
          `query getManualTraceroute { getManualTraceroute(
                    notif_id: ` +
          this.notification_id +
          `         
                    ) { 
                        tr_result
                        tr_timestamp
                    } 
                }`;

//        console.log(trQuery);
        const trData = await API.graphql(graphqlOperation(trQuery));
        if (!trData) {
          this.manTrRun=false
          this.manTrQueued=false
          var tr = false;
        } else {
          var tr = trData.data.getManualTraceroute;
//          console.log(tr);
          if (tr.length > 0) {
//            console.log("length>0")
            if (tr[0].tr_timestamp>0) {
//              console.log("timestamp>0")
              var dd = new Date(parseInt(tr[0].tr_timestamp) * 1000);
              var ddd = this.convertEpochtoTimeDate(parseInt(tr[0].tr_timestamp))
              var tr_r = tr[0].tr_result;
  //            console.log(tr_r)
              this.tr_result_man = JSON.parse(tr_r);
              this.tr_ts_man =
                dd.toISOString().slice(0, 10) +
                " " +
                dd.toISOString().slice(11, 16);
              this.tr_ts_man = ddd.date + " " + ddd.time
 //             console.log("running reformat 3")
              this.manTrQueued=false
              this.manTrRun=true;
              this.reformatTr(3);
            } else {
              this.tr_loading = false;
            }
          } else {
            this.tr_loading = false;
          }
        }
      } catch (err) {
        console.log(err);
        this.tr_loading = false;
      }
    },
    getTraceroute: async function (tr_type) {
      //console.log("RUNNING TR");
      this.tr_loading = true;
      var spl = this.paramsCombined.split("~");
      var pre = spl[0];
      var ts = spl[3];
      try {
        var trQuery =
          `query getTraceroute { getTraceroute(
                    tr_type: ` +
          tr_type +
          `,
                    timestamp: ` +
          ts +
          `,
                    p_prefix: "` +
          pre +
          `"
                    
                    ) { 
                        tr_result
                        tr_timestamp
                    } 
                }`;

        //console.log(trQuery);
        const trData = await API.graphql(graphqlOperation(trQuery));
        if (!trData) {
          var tr = false;
        } else {
          var tr = trData.data.getTraceroute;
          //console.log(tr);
          if (tr.length > 0) {
            var dd = new Date(parseInt(tr[0].tr_timestamp) * 1000);
            var ddd = this.convertEpochtoTimeDate(parseInt(tr[0].tr_timestamp))
            if (tr_type == 1) {
              var tr_r = tr[0].tr_result;
              //console.log(tr_r)
              this.tr_result_1 = JSON.parse(tr_r);
              //console.log(this.tr_result_1)
              this.tr_ts_1 =
                dd.toISOString().slice(0, 10) +
                " " +
                dd.toISOString().slice(11, 16);
              this.tr_ts_1 = ddd.date + " " + ddd.time
              this.reformatTr(1);
            } else if (tr_type == 2) {
              var tr_r = tr[0].tr_result;
              //console.log(tr_r)
              this.tr_result_2 = JSON.parse(tr_r);
              this.tr_ts_2 =
                dd.toISOString().slice(0, 10) +
                " " +
                dd.toISOString().slice(11, 16);
              this.tr_ts_2 = ddd.date + " " + ddd.time
              this.reformatTr(2);
            }
          } else {
            this.tr_loading = false;
            this.tr_title = "No traceroute found (click to hide)";
          }
        }
      } catch (err) {
        console.log(err);
        this.tr_loading = false;
        this.tr_title = "No traceroute found (click to hide)";
      }
    },
    getEpisodesMultipleRecent: async function () {
      try {
        this.mult_loading = true;
        var asn = this.currentEpisodeData[0].origin_asn_new;
        var time = this.currentEpisodeData[0].time_5min;
        var orderby = "time_5min";
        var getSearchEpisodesQuery =
          `query getEpisodesASN { getEpisodesASN(
                    asn: "` +
          asn +
          `",
                    time_from: ` +
          (time - 1800) +
          `,
                    time_to: ` +
          (time + 1800) +
          `,
                    h_greater_than: ` +
          0 +
          `,
                    i_greater_than: ` +
          0 +
          `,
                    h_less_than: ` +
          99 +
          `,
                    i_less_than: ` +
          99 +
          `,
                    order_by: "` +
          orderby +
          `//hijack_score_mean",
            offset: 0,
            limit: 10000 ) { 
                prefix 
                origin_asn_new
                origin_asn_old
                time_5min
                human_time
                hijack_score_mean
                impact_score_mean
                event_count
                } 
            }`;
        //console.log(getSearchEpisodesQuery);
        const episodeData = await API.graphql(
          graphqlOperation(getSearchEpisodesQuery)
        );
        if (!episodeData) {
          var episode = false;
        } else {
          var episode = episodeData.data.getEpisodesASN;
          //console.log("Multiple recent alerts");
          //console.log(episode);
        }
      } catch (err) {
        var episode = false;
        console.log(err);
      }
      if (episode) {
        var episode_tally = {};
        for (var k = 0; k < episode.length; k++) {
//          var datetime = episode[k].human_time.split(" ");
//          episode[k].datetime = { date: datetime[0], time: datetime[1] };
          var datetime = this.convertEpochtoTimeDate(episode[k].time_5min)
          episode[k].datetime = { date: datetime.date, time: datetime.time };

          if (
            !this.asn_get_owner.includes(episode[k].origin_asn_new.toString())
          ) {
            this.asn_get_owner.push(episode[k].origin_asn_new.toString());
          }
          if (
            !this.asn_get_owner.includes(episode[k].origin_asn_old.toString())
          ) {
            this.asn_get_owner.push(episode[k].origin_asn_old.toString());
          }

          if (!(episode[k].prefix in episode_tally)) {
            episode_tally[episode[k].prefix] = {
              asserted_over: 0,
              path_change: 0,
              asserting_over: 0,
              first_seen: 0,
            };
          }
          if (episode[k].origin_asn_new == episode[k].origin_asn_old) {
            episode_tally[episode[k].prefix]["path_change"] += 1;
          } else if (episode[k].origin_asn_old == 0) {
            episode_tally[episode[k].prefix]["first_seen"] += 1;
          } else if (episode[k].origin_asn_new == asn) {
            episode_tally[episode[k].prefix]["asserting_over"] += 1;
          } else {
            episode_tally[episode[k].prefix]["asserted_over"] += 1;
          }

          if (k == episode.length - 1) {
            this.getASNOwners("multiple");
          }
        }
        //console.log(episode_tally)
        var prefixes = Object.keys(episode_tally);
        if (prefixes.length > 1) {
          var assert_count = 0;
          for (var i = 0; i < prefixes.length; i++) {
            if (
              episode_tally[prefixes[i]]["asserting_over"] > 0 &&
              prefixes[i] != this.currentEpisodeData[0].prefix
            ) {
              assert_count += 1;
            }
          }
          if (assert_count > 0) {
            this.mult_msg_colour = "red";
            this.mult_message = assert_count.toString() + " other prefixes";
            this.mult_msg_tooltip =
              assert_count.toString() +
              " other prefixes have had ownership asserted over by this ASN in +-30mins of this alert occurring";
          } else {
            this.mult_msg_colour = "success";
            this.mult_message = "No other prefixes";
            this.mult_msg_tooltip =
              "No other prefixes have had ownership asserted over by this ASN in +-30mins of this alert occurring";
          }
        } else {
          this.mult_message = "No other prefixes";
          this.mult_msg_tooltip =
            "No other prefixes have had ownership asserted over by this ASN in +-30mins of this alert occurring";
        }
        var episode_tally_table = [];
        for (var i = 0; i < prefixes.length; i++) {
          episode_tally_table.push({
            prefix: prefixes[i],
            asserted_over: episode_tally[prefixes[i]]["asserted_over"],
            path_change: episode_tally[prefixes[i]]["path_change"],
            asserting_over: episode_tally[prefixes[i]]["asserting_over"],
            first_seen: episode_tally[prefixes[i]]["first_seen"],
          });
        }
        this.mult_tally = episode_tally_table;
        this.mult_all_episodes = episode;
        this.mult_loading = false;
        this.mult_title = "Recent alerts for AS" + asn.toString();
        this.mult_show_banner = false;
        this.$nextTick(() => {
          // Add the component back in
          this.mult_show_banner = true;
        });
      } else {
        this.mult_loading = false;
        this.mult_title = "No recent alerts found (click to hide)";
      }
    },
    flipMult: async function () {
      if (this.mult_enable) {
        this.mult_show = !this.mult_show;
        if (this.mult_show) {
          this.mult_title =
            "Recent alerts for AS" + this.currentEpisodeData[0].origin_asn_new;
          this.mult_show_banner = false;
          this.$nextTick(() => {
            // Add the component back in
            this.mult_show_banner = true;
          });
        } else {
          this.mult_title =
            "Recent alerts for AS" + this.currentEpisodeData[0].origin_asn_new;
          this.mult_show_banner = false;
          this.$nextTick(() => {
            // Add the component back in
            this.mult_show_banner = true;
          });
        }
      } else {
        this.mult_show_banner = false;
      }
    },
    refreshList: async function (t) {
      if (t == 0) {
        this.timeSimilar = "past/ future 30m";
      } else {
        this.timeSimilar = "past " + String(t) + "h";
      }
      this.getSimilarEpisodes(
        this.currentEpisodeData[0].origin_asn_new,
        this.currentEpisodeData[0].prefix,
        this.currentEpisodeData[0].time_5min,
        t * 3600,
        "time_5min",
        this.currentEpisodeData[0].origin_asn_old
      );
    },
    getSimilarEpisodes: async function (
      asn,
      prefix,
      time,
      time_back,
      orderby,
      o_asn
    ) {
      try {
        this.showSimilarLoad = true;
        if (time_back == 0) {
          var getSearchEpisodesQuery =
            `query getSearchEpisodesQuery { getSearchEpisodes(
                    asn: "` +
            asn +
            `",
                    prefix: "` +
            prefix +
            `",
                    time_from: ` +
            (time - 1800) +
            `,
                    time_to: ` +
            (time + 1800) +
            `,
                    h_greater_than: ` +
            0 +
            `,
                    i_greater_than: ` +
            0 +
            `,
                    h_less_than: ` +
            99 +
            `,
                    i_less_than: ` +
            99 +
            `,
                    order_by: "` +
            orderby +
            `//hijack_score_mean",
                    exclude_path_change: ` +
            false +
            `,
                    exclude_first_seen: ` +
            false +
            `,
                    offset: 0,
                    limit: 1000 ) { 
                        prefix 
                        origin_asn_new
                        origin_asn_old
                        time_5min
                        human_time
                        hijack_score_mean
                        impact_score_mean
                        event_count
                        } 
                    }`;
        } else {
          var getSearchEpisodesQuery =
            `query getSearchEpisodesQuery { getSearchEpisodes(
                    asn: "` +
            asn +
            `",
                    prefix: "` +
            prefix +
            `",
                    time_from: ` +
            (time - time_back) +
            `,
                    time_to: ` +
            time +
            `,
                    h_greater_than: ` +
            0 +
            `,
                    i_greater_than: ` +
            0 +
            `,
                    h_less_than: ` +
            99 +
            `,
                    i_less_than: ` +
            99 +
            `,
                    order_by: "` +
            orderby +
            `//hijack_score_mean",
                    exclude_path_change: ` +
            false +
            `,
                    exclude_first_seen: ` +
            false +
            `,
                    offset: 0,
                    limit: 100 ) { 
                        prefix 
                        origin_asn_new
                        origin_asn_old
                        time_5min
                        human_time
                        hijack_score_mean
                        impact_score_mean
                        event_count
                        } 
                    }`;
        }
        //console.log(getSearchEpisodesQuery);
        const episodeData = await API.graphql(
          graphqlOperation(getSearchEpisodesQuery)
        );
        if (!episodeData) {
          var episode = false;
        } else {
          var episode = episodeData.data.getSearchEpisodes;
          //console.log(episode);
        }
      } catch (err) {
        console.log("An error has occurred");
        //this.$store.state.lastSearch = false;
        //this.erColor = "red";
        //this.resError = err.errors[0].message;
        this.similarEpisodes = [];
        this.showSimilarLoad = false;
      }

      if (!episode) {
        this.similarEpisodes = [];
        //this.$store.state.lastSearch = false;
      } else {
        if (episode.length == 0 || episode === undefined || !episode) {
          this.similarEpisodes = [];
          //this.erColor = "success";
          //this.resError = "No episodes found.";
          //this.$store.state.lastSearch = false;
        } else {
          for (var i = 0; i < episode.length; i++) {
            //var datetime = episode[i].human_time.split(" ");
            var datetime = this.convertEpochtoTimeDate(episode[i].time_5min)
            // episode[i].datetime = { date: datetime[0], time: datetime[1] };
            episode[i].datetime = { date: datetime.date, time: datetime.time };

            if (
              !this.asn_get_owner.includes(episode[i].origin_asn_new.toString())
            ) {
              this.asn_get_owner.push(episode[i].origin_asn_new.toString());
            }
            if (
              !this.asn_get_owner.includes(episode[i].origin_asn_old.toString())
            ) {
              this.asn_get_owner.push(episode[i].origin_asn_old.toString());
            }

            if (i == episode.length - 1) {
              this.getASNOwners("similar");
            }

            this.showSimilarLoad = true;
            this.$nextTick(() => {
              // Add the component back in
              this.showSimilarLoad = false;
            });
          }
          for (var i = 0; i < episode.length; i++) {
            if (
              episode[i].prefix == prefix &&
              episode[i].origin_asn_new == asn &&
              episode[i].origin_asn_old == o_asn &&
              episode[i].time_5min == time
            ) {
              episode.splice(i, 1);
            }
          }
          this.similarEpisodes = episode;
          this.$nextTick(() => {
            // Add the component back in
            this.showSimilarLoad = false;
          });
          /*this.$store.state.lastSearch = {
                        type: "Episodes",
                        form: this.searchForm,
                        timeFrom: this.timeFrom,
                        timeTo: this.timeTo,
                        iSlider: this.isliderRange,
                        hSlider: this.hsliderRange
                    };*/
        }
      }
      this.showSimilar = true;
      this.showSimilarLoad = false;
      //this.showForm = false;
    },
    getASNOwners: async function (type) {
      this.is_asn_owners[type] = false;
      //console.log("getting asn owners: " + type);
      for (var i = 0; i < this.asn_get_owner.length; i++) {
        var keys = Object.keys(this.asn_own_dict);
        if (!keys.includes(this.asn_get_owner[i].toString())) {
          this.asn_own_dict[this.asn_get_owner[i]] = await this.getAnASNOwner(
            this.asn_get_owner[i]
          );
        }
        if (i == this.asn_get_owner.length - 1) {
          this.is_asn_owners[type] = true;
        }
      }
    },
    getAnASNOwner: async function (asn) {
      if (asn == 0) {
        return "None";
      } else {
        try {
          var qry =
            `query getASNOwner { getASNOwner ( asn: "` +
            asn +
            `" ) {
                      organisation
                  }
              }`;
        //  console.log(qry);
          const res = await API.graphql(graphqlOperation(qry));
          var ownData = res.data.getASNOwner;
          //console.log(ownData);
          if (ownData) {
            if (ownData.length > 0) {
              //console.log("owner: ");
              //console.log(ownData[0].organisation);
              if (ownData[0].organisation) {
                return ownData[0].organisation;
              } else {
                return "Unknown";
              }
            } else {
              return "Unknown";
            }
          } else {
            return "Unknown";
          }
        } catch (err) {
          console.log(err);
          return "Unknown";
        }
      }
    },
    rawDownload: async function (epoch) {
      //Format required 2019-04-11 03:45:00
      var d = new Date(epoch * 1000);
      var day = ("0" + d.getUTCDate()).slice(-2);
      var month = ("0" + (d.getUTCMonth() + 1)).slice(-2);
      var year = d.getUTCFullYear();
      var dateFormatted = year + "-" + month + "-" + day;
      var timeFormatted =
        ("0" + d.getUTCHours()).slice(-2) +
        ":" +
        ("0" + d.getUTCMinutes()).slice(-2) +
        ":00";

      var query =
        `query getURLFromS3 { 
          getURLFromS3(date: "` +
        dateFormatted +
        `", time: "` +
        timeFormatted +
        `", time_range: 15) 
                { url
            } 
        }`;

      //console.log(query);

      const returnURLs = await API.graphql(graphqlOperation(query));
      //console.log(returnURLs);

      if (returnURLs.data.getURLFromS3 != false) {
        this.downloadLinkData = returnURLs.data.getURLFromS3[1];

        // This query downloads two types of data, CSP ingest and Route Views ingest. I've ommited
        // CSP ingest as I seem to remember there being some contension about allowing all users to download this.
        // Its easy to do both but i chose to just do route Views - may need further discussion.
      } else {
        this.downloadLinkData = false;
      }
    },
    isInt(str) {
//      console.log(!isNaN(str))
//      console.log(Number.isInteger(parseFloat(str)))
      return !isNaN(str) && Number.isInteger(parseFloat(str));
    },
    checkEpisodeInfoIsInGoodKnick: async function (paramsCombined) {
      var validdata=true;
      var testtime=0;
      try {
        if (this.dummy) {
          var dummy_str = ', dummy: 1'
        } else {
          var dummy_str = ', dummy: 0'
        }
        var paramsSplit = paramsCombined.split("~");
        this.prefixInQ = paramsSplit[0];
        //console.log("In initial query...");
//        console.log(paramsSplit);
        try {
          if (!this.isInt(paramsSplit[1])) {
            validdata=false;
//            console.log("asn1 is not a number")
          }
          if (!this.isInt(paramsSplit[2])) {
            validdata=false;
//            console.log("asn1 is not a number")
          }
          if (!this.isInt(paramsSplit[3])) {
            validdata=false;
//            console.log("time is not a number :"+paramsSplit[3]+":")
          }
          var timenow=Math.floor(new Date().getTime() / 1000)
          var tooold=timenow-(3600*24*30)
//          console.log(timenow)
//          console.log(tooold)
          testtime=Number(paramsSplit[3])
          if (testtime<tooold || testtime>timenow) {
//            console.log(timenow-testtime)
            validdata=false;
//            console.log("Time is out")
          }
        } catch {
          console.log("error")
          validdata=false
        }
        if (validdata) {
          var getEventsForEpsiodeQuery =
            `query test { getEpisodeFromInputs(   
                prefix: "` +
            paramsSplit[0] +
            `", 
                o_asn_new: "` +
            paramsSplit[2] +
            `", 
                o_asn_old: "` +
            paramsSplit[1] +
            `",
                time_5min: ` +
            paramsSplit[3] + dummy_str +
            `) {
                prefix,
                origin_asn_new,
                origin_asn_old,
                hijack_score_mean,
                impact_score_mean,
                event_count,
                time_5min,
                human_time
                    }
                }`;
          //console.log(getEventsForEpsiodeQuery);
          const EpisodeData = await API.graphql(
            graphqlOperation(getEventsForEpsiodeQuery)
          );
          //console.log(EpisodeData);
          var episode = EpisodeData.data.getEpisodeFromInputs;
          if (episode.length>0) {
            var datetime = this.convertEpochtoTimeDate(episode[0].time_5min)
            //episode[k].datetime = { date: datetime.date, time: datetime.time };
  //          var datetime = episode[0].human_time.split(" ");
            if (
              !this.asn_get_owner.includes(episode[0].origin_asn_new.toString())
            ) {
              this.asn_get_owner.push(episode[0].origin_asn_new.toString());
            }
            if (
              !this.asn_get_owner.includes(episode[0].origin_asn_old.toString())
            ) {
              this.asn_get_owner.push(episode[0].origin_asn_old.toString());
            }
            this.getASNOwners("main");

  //          episode[0].datetime = { date: datetime[0], time: datetime[1] };
            episode[0].datetime = { date: datetime.date, time: datetime.time };
            this.getSimilarEpisodes(
              episode[0].origin_asn_new,
              episode[0].prefix,
              episode[0].time_5min,
              0,
              "time_5min",
              episode[0].origin_asn_old
            );
            //episode[0].new_owner = "";
            //episode[0].old_owner = "";
            this.currentEpisodeData = episode;
            this.getNotificationForEpisode(episode[0]);
            //this.rawDownload(episode[0].time_5min);
            this.getEpisodesMultipleRecent();

          } else {
            console.log("INVALID REQUEST")
            console.log(getEventsForEpsiodeQuery)
            console.log(episode)
            this.invalidRequest=true;
          }
        } else {
          console.log("INVALID DATA")
          this.invalidRequest=true;
        }
      } catch (err) {
        this.invalidRequest=true;
        console.log(err);
      }
    },
    getNotificationForEpisode: async function (episode) {
      try {
        var getNotifForEpisode =
          `query getNotificationForEpisode { getNotificationForEpisode(   
            p_prefix: "` +
          episode.prefix +
          `", 
            o_asn_new: "` +
          episode.origin_asn_new +
          `", 
            o_asn_old: "` +
          episode.origin_asn_old +
          `",
            episode_start: ` +
          episode.time_5min +
          `,
            p_organisation: "` +
          this.organisation +
          `"
            ) {
          prefix,
          hijack_score_mean,
          impact_score_mean,
          asn_of_interest,
          user,
          notification_id,
          man_tr
          }
        }`;
        const NotifData = await API.graphql(
          graphqlOperation(getNotifForEpisode)
        );
        var Notif = NotifData.data.getNotificationForEpisode;
        //console.log("NOTIFICATION PULLED");
        //console.log(Notif);
        for (var i = 0; i < Notif.length; i++) {
          var notif = Notif[i];
          if (notif.asn_of_interest == "99999999999") {
            if (notif.user == "whole_organisation") {
              this.org_impact = notif.impact_score_mean;
            }
            if (notif.user == this.user) {
              this.user_impact = notif.impact_score_mean;
            }
          }
        }
        if (Notif.length>0) {
          this.notification_id=notif.notification_id
          this.manTrQueued=false
          this.manTrRun=false
          if (notif.man_tr!=null) {
            if (notif.man_tr==0) {
              this.manTrQueued=true
            } else {
              this.manTrRun=true
              this.getManTraceroute();
  //            console.log("Set run=true")
            }
          }          
        } else {
          this.notification_id=0
        }
        //console.log("Getting events...");
        this.getScoredEpisodeFromURLParams(episode);
      } catch (err) {
        console.log(err);
      }
    },
    getScoredEpisodeFromURLParams: async function (episode) {
      if (!this.disag_prefixes.includes(episode.prefix)) {
        this.disag_prefixes.push(episode.prefix);
      }

      if (this.dummy) {
        var dummy_str = ', dummy: 1'
      } else {
        var dummy_str = ', dummy: 0'
      }

      var getEventsForEpisodeQuery =
        `query getEventsForEpisodeQuery { getEventsForEpisode( 
            prefix: "` +
        episode.prefix +
        `", 
            origin_asn_new: "` +
        episode.origin_asn_new +
        `", 
            origin_asn_old: "` +
        episode.origin_asn_old +
        `", 
            episode_start: ` +
        episode.time_5min +
        `, 
            page_offset: 0, 
            page_rows: 1000 ` + dummy_str + `) { 
                prefix 
                origin_asn_new
                origin_asn_old
                episode_start
                peer_asn
                path_new
                path_old
                hijack_scope
                hijack_subtype
                edit_distance
                pathchange_type
                asn_geocomparison
                prefix_vs_asn_geo
                restricted_dns
                bogon
                route_leak_flag
                hijack_score
                impact_score
                event_count
                non_direct_asn_type
                non_direct_prefix
                peer_ip
                collector
                time_5min
                time_exact
                obs_disag
                ref_disag
                non_direct_asn
                derived_type
                ddos_mitigator
                common_owner
                as_in_path_risk
                } 
            }`;
      //console.log(getEventsForEpisodeQuery);
      const eventData = await API.graphql(
        graphqlOperation(getEventsForEpisodeQuery)
      );
      //console.log(eventData);
      var event = eventData.data.getEventsForEpisode;
      var oldAndNewPath = {
        //This is for pathchange vis
        pathsBeforeAnnomaly: [],
        pathsAfterAnnomaly: [],
      };
      if (event.length > 0) {
        for (var n = 0; n < event.length; n++) {
          var evbds = this.scoreBreakdown(event[n]);
          event[n].score_breakdown = evbds[0];
          event[n].score_breakdown_array = evbds[1];
          if (event[n].path_old == "empty" || !event[n].path_old) {
            event[n].path_old = "N/A";
          }
          //console.log("scorebd")
          //console.log(event[n].score_breakdown)
          //console.log("scorebdarray")
          //console.log(event[n].score_breakdown_array)
          if (!this.asn_get_owner.includes(event[n].peer_asn.toString())) {
            this.asn_get_owner.push(event[n].peer_asn.toString());
          }

          if (!event[n].pathchange_type) {
            event[n].pathchange_type = "N/A";
          }
          if (!event[n].bogon) {
            event[n].bogon = "N/A";
          }
          if (!event[n].restricted_dns) {
            event[n].restricted_dns = "N/A";
          } else {
            event[n].derived_type = "Restricted DNS";
          }

          if (
            event[n].path_old == "N/A" &&
            event[n].non_direct_asn_type != "null" && event[n].non_direct_asn_type
          ) {
            if (this.headersEvent[3].text != "Non-direct Prefix") {
              this.headersEvent[3] = {
                ad_text:
                  "Non-direct ASN refers to the authorative owner of either the parent or child prefix in this event.\n In this case there will be no 'old path' as we are basing the ownership assertion on reference data of the parent/ child.\n The non-direct ASN type is either authorative (i.e. from reference data) or observed (i.e. from live data).",
                align: "centre",
                text: "Non-direct ASN type",
                value: "non_direct_asn_type",
              };
            } else {
              this.headersEvent[3] = {
                ad_text:
                  "Non-direct ASN refers to the authorative owner of either the parent or child prefix in this event.\n In this case there will be no 'old path' as we are basing the ownership assertion on reference data of the parent/ child.\n The non-direct ASN type is either authorative (i.e. from reference data) or observed (i.e. from live data).",
                align: "centre",
                text: "Non-direct ASN type",
                value: "non_direct_asn_type",
              };
            }
            this.event_indirect = true;
            if (event[n].non_direct_asn_type == "obs") {
              event[n].non_direct_asn_type = "Observed";
            }
            if (event[n].non_direct_asn_type == "auth") {
              event[n].non_direct_asn_type = "Authoritive";
            }
          }

          if (event[n].non_direct_prefix) {
            if (this.headersEvent[3].text != "Non-direct Prefix") {
              this.headersEvent.splice(3, 0, {
                ad_text:
                  "Non-direct prefix is the prefix of the parent/ child having sub/ super ownership asserted over",
                align: "centre",
                text: "Non-direct Prefix",
                value: "non_direct_prefix",
              });
              this.event_indirect_prefix = true;
            }
          } else {
            event[n].non_direct_prefix = "N/A";
          }
          var d = this.convertEpochtoTimeDate(event[n].time_exact)
//          var d = new Date(event[n].time_exact * 1000);
//          var day = ("0" + d.getUTCDate()).slice(-2);
//          var month = ("0" + (d.getUTCMonth() + 1)).slice(-2);
//          var year = d.getUTCFullYear();
//          var dateFormatted = day + "/" + month + "/" + year;
//          var timeFormatted =
//            ("0" + d.getUTCHours()).slice(-2) +
//            ":" +
//            ("0" + d.getUTCMinutes()).slice(-2) +
//            ":" +
//            ("0" + d.getUTCSeconds()).slice(-2);
          event[n].exact_time = d.date + " " + d.time;

          if (n == event.length - 1) {
            this.getASNOwners("event");
          }

          oldAndNewPath.pathsAfterAnnomaly.push(event[n].path_new.split(" "));
          if (event[n].path_old != "") {
            oldAndNewPath.pathsBeforeAnnomaly.push(
              event[n].path_old.split(" ")
            );
          }

          event[n].ev_type = "";
          event[n].controlled_pre_show = "N/A";

          if (this.org_impact != 0 || this.user_impact != 0) {
            event[n].impact_score = Math.max(this.org_impact, this.user_impact);
            event[n].controlled_pre_show = event[n].controlled_prefix;
            //eventType.push({name: "Restricted Prefix Advertised", value: event[n].controlled_prefix, fatal: true})
            //eventType.push({name: "Restricted Prefix Organisation", value: event[n].controlled_prefix_orgs, fatal: false})
            event[n].ev_type = "Restricted Prefix";
          } /* else if (event[n].bogon != "null") {
            //eventType.push({name: "Bogon Advertised", value: event[n].bogon, fatal: true})
            event[n].ev_type = "Bogon";
          } else if (event[n].restricted_dns != "null") {
            //eventType.push({name: "Route DNS Server Advertised", value: event[n].restricted_dns, fatal: true})
            event[n].ev_type = "Restricted DNS";
          } else if (event[n].origin_asn_old == 0) {
            event[n].ev_type = "First Seen Prefix";
          } else if (event[n].hijack_scope > 0 && (event[n].hijack_subtype != 'null' || event[n].path_old.length > 5)) {
            if (event[n].hijack_subtype == "full") {
              event[n].ev_type = "Full Subownership Assertion";
            } else {
              event[n].ev_type = "Previously Observed Subownership Assertion";
            }
          } else if (event[n].origin_asn_old == event[n].origin_asn_new) {
            if (event[n].pathchange_type != -1) {
              event[n].ev_type = "Path Change " + event[n].pathchange_type;
            } else {
              event[n].ev_type = "Path Change";
            }
          } else if (event[n].hijack_scope == 0) {
            if (event[n].hijack_subtype == "full") {
              event[n].ev_type = "Full Ownership Assertion";
            } else {
              event[n].ev_type = "Previously Observed Ownership Assertion";
            }
          } else if (event[n].hijack_scope < 0) {
            if (event[n].hijack_subtype == "full") {
              event[n].ev_type = "Full Superownership Assertion";
            } else {
              event[n].ev_type = "Previously Observed Superownership Assertion";
            }
          } else {
            event[n].ev_type = "Other";
          } */

          // End of event type code

          var obs_disag = JSON.parse(event[n].obs_disag);
          //console.log(obs_disag);
          if (obs_disag != null){
            if (obs_disag.parent) {
              if (obs_disag.parent.prefix) {
                var cidr = parseInt(obs_disag.parent.prefix.split("/")[1]);
                if (
                  !this.disag_prefixes.includes(obs_disag.parent.prefix) &&
                  cidr > 7
                ) {
                  this.disag_prefixes.push(obs_disag.parent.prefix);
                }
              }
            }

            if (obs_disag.children) {
              for (var i = 0; i < obs_disag.children.length; i++) {
                if (obs_disag.children[i].ag_pref) {
                  for (
                    var j = 0;
                    j < obs_disag.children[i].ag_pref.addtl.length;
                    j++
                  ) {
                    if (
                      !this.disag_prefixes.includes(
                        obs_disag.children[i].ag_pref.common +
                          obs_disag.children[i].ag_pref.addtl[j]
                      )
                    ) {
                      this.disag_prefixes.push(
                        obs_disag.children[i].ag_pref.common +
                          obs_disag.children[i].ag_pref.addtl[j]
                      );
                    }
                  }
                } else if (
                  !this.disag_prefixes.includes(obs_disag.children[i].prefix)
                ) {
                  this.disag_prefixes.push(obs_disag.children[i].prefix);
                }
              }
            }
          }

          var myDate = new Date(event[n].time_exact * 1000);
          event[n].event_time = myDate;
        }
        //console.log("marker 3, loop to edit event is done");
        //console.log(this.disag_prefixes);

        this.scored_Event_Data = event;
        //this.graphdata = this.createScoringGraphData(event);
        this.id = this.id + 1;
        this.oldAndNewPath = oldAndNewPath;
        this.idForPath = this.idForPath + 1;
        //console.log("marker 4, all done!");
        if (event.length == 1) {
          this.clickHandler(
            event[0].score_breakdown,
            event[0].score_breakdown_array
          );
        }
        //console.log("getting disag data");
        this.getDisagData();
      }
    },
    disagShard: async function (pre_str, event_time, n) {
      try {
        //console.log("starting shard " + n.toString());
        var query =
          `query getDisagEvents {
            getDisagEvents (
              pre_str: "` +
          pre_str +
          `",
              event_time: ` +
          event_time +
          `,
              hours_back: ` +
          n +
          `
            ) {
              prefix 
              origin_asn_new
              origin_asn_old
              time_exact
              time_5min
              peer_asn
            }  
          }`;
        const queryRes = await API.graphql(graphqlOperation(query));

        this.awaited += 1;
        if (queryRes.data.getDisagEvents) {
          //console.log(queryRes.data.getDisagEvents)
          return queryRes.data.getDisagEvents;
        } else {
          return [];
        }
      } catch (err) {
        console.log(err);
        return [];
      }
    },
    getDisagData: async function () {
      try {
        this.disag_events = [];
        this.awaited = 0;
        this.send_disag = false;
        var hours_to_go = 48;
        var prefixes_combined = "";
        for (var i = 0; i < this.disag_prefixes.length; i++) {
          if (i != 0) {
            prefixes_combined += ",";
          }
          prefixes_combined += "'";
          prefixes_combined += this.disag_prefixes[i];
          prefixes_combined += "'";
        }
        //console.log("PREFIX STR : " + prefixes_combined.length.toString());
        var to_run = [];
        for (var i = 0; i < hours_to_go; i++) {
          to_run.push(
            this.disagShard(
              prefixes_combined,
              this.currentEpisodeData[0].time_5min,
              i
            )
          );
        }

        var all_events = [];
        var results = [];

        for (var i = 0; i < hours_to_go; i++) {
          results.push(await to_run[i]);
          /*console.log(events.length.toString() + " events " + i.toString())
          for (var i = 0 ; i < events.length ; i++ ) {
            all_events.push(events[i])
          }*/
        }

        //console.log(results)
        for (var i = 0; i < hours_to_go; i++) {
          for (var j = 0; j < results[i].length; j++) {
            all_events.push(results[i][j]);
          }
        }

        //console.log(all_events.length.toString() + " (all events)");
        this.disag_events = all_events;

        if (this.awaited == hours_to_go) {
          //console.log("ALL SHARDS DONE");
          
        }
        //console.log(this.disag_events);
        //console.log("ALL DONE");
        this.send_disag = true;
      } catch (err) {
        console.log(err);
      }
    },
    clickHandler: async function (bd, bda) {
      //console.log("BD")
      //console.log(bd)
      //console.log("BDA")
      //console.log(bda)
      this.scoreBD = bd.split("\n");
      this.scoreBDarray = bda;
      this.showBD = true;
    },
    clickHandlerEpisode: function (prefix, old_asn, new_asn, time) {
      var paramatersCombined =
        prefix + "~" + old_asn + "~" + new_asn + "~" + time;

      let routeData = this.$router.resolve({
        name: "Alert From Top 10",
        params: { prefix: paramatersCombined },
      });
        window.open(routeData.href, "_blank");
      /*this.$router.push({
        name: "Alert From Top 10",
        params: { prefix: paramatersCombined },
      });*/
    },
    scoreBreakdown: function (event) {
      var specialcase = false;
      var bdstr = "Hijack and Impact scores begin both at 0. \n";
      var bdblock = [
        {
          name: "Special Case",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Scope",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Path Based",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Origin ASN Geo",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Prefix vs. ASN Geo",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Superownership / Route Leak",
          h: 0,
          i: 0,
          exp: "",
        },
        {
          name: "Restricted Prefix",
          h: "-",
          i: "-",
          exp: "",
        },
        {
          name: "FINAL",
          h: 0,
          i: 0,
          exp: "",
        },
      ];
      var h = 0;
      var i = 0;
      //console.log("EVENT");
      //console.log(event);

      if (event.bogon != "null") {
        bdstr += "We have hit a bogon, so all scores are set to 99 \n";
        bdstr += "H = 99\n";
        bdstr += "I = 99\n";
        h = 99;
        i = 99;
        bdblock[0].exp = "We have hit a bogon, so all scores are set to 99";
        bdblock[0].h = 99;
        bdblock[0].i = 99;
        bdblock[7].h = 99;
        bdblock[7].i = 99;
        specialcase = true;
      } else {
        bdblock[0].exp = "No bogon detected";
      }

      if (event.restricted_dns != "null") {
        bdstr +=
          "We have hit a restricted DNS entry (e.g. global root DNS server), so all scores are set to 99 \n";
        bdstr += "H = 99\n";
        bdstr += "I = 99\n";
        h = 99;
        i = 99;
        bdblock[0].exp =
          "We have hit a restricted DNS entry (e.g. global root DNS server), so all scores are set to 99";
        bdblock[0].h = 99;
        bdblock[0].i = 99;
        bdblock[7].h = 99;
        bdblock[7].i = 99;
        specialcase = true;
      } else {
        bdblock[0].exp += ", no restricted DNS detected";
      }

      if (event.hijack_scope > 0) {
        if (event.hijack_subtype == "full") {
          h += 50;
          var addi = Math.max(15 - 3 * event.hijack_scope, 0);
          i += addi;
          bdstr +=
            "We have a full subownership assertion (i.e. unseen prior ownership). \n";
          bdblock[1].exp =
            "We have a full subownership assertion (i.e. unseen prior ownership).";
          bdblock[1].h = 50;
          bdblock[1].i = addi;
          bdstr += "Hijack score += 50 \n";
          bdstr += "Impact score += max( 15 - 3 * hijack_scope, 0) = ";
          bdstr += addi;
          bdstr += " \n";
          bdstr += "H = " + h + "\n";
          bdstr += "I = " + i + "\n";
        } else if (event.hijack_subtype == "observed") {
          h += 30;
          var addi = Math.max(15 - 3 * event.hijack_scope, 0);
          i += addi;
          bdstr += "We have a previously observed subownership assertion. \n";
          bdblock[1].exp =
            "We have a previously observed subownership assertion.";
          bdblock[1].h = 30;
          bdblock[1].i = addi;
          bdstr += "Hijack score += 30 \n";
          bdstr += "Impact score += 15 - 3 * [hijack scope] (min 0) = ";
          bdstr += addi;
          bdstr += " \n";
          bdstr += "H = " + h + "\n";
          bdstr += "I = " + i + "\n";
        } else {
          bdstr +=
            "Path change event, so don't apply scope based analytics. \n";
          bdblock[1].exp =
            "Path change event, so don't apply scope based analytics.";
        }
      } else if (event.hijack_scope == 0) {
        if (event.hijack_subtype == "full") {
          h += 40;
          i += 15;
          bdstr +=
            "We have a full ownership assertion (i.e. unseen prior ownership). \n";
          bdblock[1].exp =
            "We have a full ownership assertion (i.e. unseen prior ownership).";
          bdblock[1].h = 40;
          bdblock[1].i = 15;
          bdstr += "Hijack score += 40 \n";
          bdstr += "Impact score += 15 \n ";
          bdstr += "H = " + h + "\n";
          bdstr += "I = " + i + "\n";
        } else if (event.hijack_subtype == "observed") {
          h += 20;
          i += 15;
          bdstr += "We have a previously observed ownership assertion. \n";
          bdblock[1].exp = "We have a previously observed ownership assertion.";
          bdblock[1].h = 20;
          bdblock[1].i = 15;
          bdstr += "Hijack score += 20 \n";
          bdstr += "Impact score += 15 \n ";
          bdstr += "H = " + h + "\n";
          bdstr += "I = " + i + "\n";
        } else {
          bdstr +=
            "Path change event, so don't apply scope based analytics. \n";
          bdblock[1].exp =
            "Path change event, so don't apply scope based analytics.";
        }
      } else {
        bdstr += "Superownership assertion so no scores are changed. \n";
      }

      if (event.origin_asn_old != 0) {
        var isnew = false;
        try {
          var oldasnpath = event.path_old.split(" ");
        } catch {
          var oldasnpath = ['']
        }
          
        var newasnpath = event.path_new.split(" ");
        var oldasns = new Set(oldasnpath);
        var newasns = new Set(newasnpath);
        //console.log("OLD ASNS")
        //console.log(oldasns);
        //console.log("NEW ASNS")
        //console.log(newasns);
        for (var asn of newasns) {
          //console.log(asn);
          //console.log(oldasns)
          if (!oldasns.has(asn)) {
            isnew = true;
            //console.log("hit")
          }
        }
        if (isnew && event.pathchange_type != -1) {
          bdstr +=
            "We have new ASNs in the path, so apply the following analytics: \n";
          var pch = Math.max(20 - 10 * event.pathchange_type, 0);
          var edh = event.edit_distance * 3;
          if (event.asn_geocomparison != -1) {
            var asnimp = Math.round(30 * (1 - event.asn_geocomparison));
            bdblock[3].exp = "ASN geo information available.";
            bdblock[3].h = 0;
            bdblock[3].i = asnimp;
          } else {
            var asnimp = 30;
            bdblock[3].exp = "Missing ASN geo information.";
            bdblock[3].h = 0;
            bdblock[3].i = 30;
          }
          h += pch;
          h += edh;
          i += asnimp;
          bdstr += "Hijack += 20 - 10 * [path change type] (min 0) = ";
          bdstr += pch;
          bdstr +=
            " (the further up the chain the new ASN appears the less likely it is to be a targeted attack) \n";
          bdstr += "Hijack += 3 * [edit distance] = ";
          bdstr += edh;
          bdstr +=
            " (the further from the original path the more likely to hit a malicious ASN) \n";
          bdstr += "Impact += 30 * (1 - [asn geo comparison]) = ";
          bdstr += asnimp;
          bdstr +=
            " (if the new ASN is hosted in a completely different geo it's likely to be a hijack) \n";
          bdblock[2].exp = "New ASNs in path, so apply path based analytics.";
          bdblock[2].h = pch + edh;
          bdblock[2].i = 0;

          bdstr += "H = " + h + "\n";
          bdstr += "I = " + i + "\n";

          if (event.registrar_flag == 1) {
            if (event.prefix_vs_asn_geo != -1) {
              var hpre = Math.round(30 * (1 - event.prefix_vs_asn_geo));
              h += hpre;
              var ipre = Math.round(50 * (1 - event.prefix_vs_asn_geo));
              i += ipre;
              bdblock[4].exp = "Prefix vs. ASN geo information available.";
              bdblock[4].h = hpre;
              bdblock[4].i = ipre;
            } else {
              var hpre = 30;
              h += hpre;
              var ipre = 50;
              i += ipre;
              bdblock[4].exp = "Prefix vs. ASN geo information missing.";
              bdblock[4].h = 30;
              bdblock[4].i = 50;
            }
            bdstr +=
              "The prefix isn't allowed to be advertised by the given origin ASN, so we apply the following analytics: \n";
            bdstr += "Hijack += 30 * (1 - [prefix vs asn geo comparison]) = ";
            bdstr += hpre;
            bdstr +=
              " (the more uncorrelated the prefix and origin AS, the more likely it is to be a hijack) \n";
            bdstr += "Impact += 50 * (1 - [prefix vs asn geo comparison]) = ";
            bdstr += ipre;
            bdstr +=
              " (a prefix being hijacked by an ASN in a completely different geo could mean a more severe impact on the former origin ASN) \n";
          } else {
            bdstr +=
              "Prefix permitted by registry data, so we don't apply prefix vs. ASN analytics to scores. \n";
            bdblock[4].exp =
              "Prefix permitted by registry data, so we don't apply prefix vs. ASN analytics to scores.";
          }
        } else {
          if (
            event.pathchange_type == -1 &&
            event.origin_asn_old != "null" &&
            event.origin_asn_old != 0
          ) {
            //super or sub ownership
            if (event.asn_geocomparison != -1) {
              var asnimp = Math.round(30 * (1 - event.asn_geocomparison));
              bdblock[3].exp = "ASN geo information available.";
              bdblock[3].h = 0;
              bdblock[3].i = asnimp;
            } else {
              var asnimp = 30;
              bdblock[3].exp = "Missing ASN geo information.";
              bdblock[3].h = 0;
              bdblock[3].i = 30;
            }
            bdstr += "Impact += 30 * (1 - [asn geo comparison]) = ";
            bdstr += asnimp;
            bdstr +=
              " (if the new ASN is hosted in a completely different geo it's likely to be a hijack) \n";
            i += asnimp;
          } else {
            bdblock[3].exp =
              "No new ASNs, so we don't apply any ASN based analytics to the scores.";
          }

          bdstr +=
            "No new ASNs, so we don't apply any ASN based analytics to the scores. \n";
          bdblock[2].exp =
            "No new ASNs, so we don't apply any ASN based analytics to the scores.";
        }
      } else {
        bdstr +=
          "New announcement, so we don't apply any ASN based analytics to the scores. \n";
        bdblock[2].exp =
          "New announcement, so we don't apply any ASN based analytics to the scores.";
        bdblock[3].exp =
          "New announcement, so we don't apply any ASN based analytics to the scores.";
      }

      if (this.org_impact != 0) {
        bdstr +=
          "We have hit an organisation restricted prefix, so impact subscore set to ";
        bdstr += this.org_impact.toString();
        bdstr += " for your organisation. \n";
        //bdstr += "Sub H = 99 \n"
        bdstr += "Sub I = ";
        bdstr += this.org_impact.toString();
        bdstr += "\n";
        bdblock[6].h = "-";
        bdblock[6].i = this.org_impact;
        bdblock[6].exp =
          "We have hit a restricted prefix, so impact subscore set to " +
          this.org_impact +
          " for your organisation.";
      } else if (this.user_impact != 0) {
        bdstr +=
          "We have hit a user restricted prefix, so impact subscore set to ";
        bdstr += this.user_impact.toString();
        bdstr += " for your user. \n";
        //bdstr += "Sub H = 99 \n"
        bdstr += "Sub I = ";
        bdstr += this.user_impact.toString();
        bdstr += "\n";
        bdblock[6].h = "-";
        bdblock[6].i = this.user_impact;
        bdblock[6].exp =
          "We have hit a restricted prefix, so impact subscore set to " +
          this.user_impact +
          " for your user.";
      }

      if (
        (event.hijack_scope < 0 || event.route_leak_flag == 1) &&
        !specialcase
      ) {
        if (event.hijack_scope < 0) {
          bdstr +=
            "We have a superownership assertion, so half the Hijack score, and cap it at 40. \n";
          bdblock[5].exp =
            "We have a superownership assertion, so half the Hijack score, and cap it at 40.";
        } else {
          bdstr +=
            "We have a route leak, so half the Hijack score, and cap it at 40. \n";
          bdblock[5].exp =
            "We have a route leak, so half the Hijack score, and cap it at 40.";
        }
        var preh = h;
        h = Math.min(Math.round(h / 2, 0), 40);
        bdblock[5].h = preh - h;
      }

      if (specialcase) {
        bdstr += "Cap scores at 99 \n";
        h = 99;
        i = 99;
        bdblock[7].exp = "Cap scores at 99";
      }

      bdstr += "H = " + h + "\n";
      bdstr += "I = " + i;
      bdblock[7].h = h;
      bdblock[7].i = i;
      //console.log(bdstr);

      return [bdstr, bdblock];
    },
    createScoringGraphData: function (allEventData) {
      var userMaxMeanAverage = this.calcUserMaxMeanAverage();

      var allEventDataMinAvgMax = {
        impact: { min: 100, avg: null, max: 0 },
        hijack: { min: 100, avg: null, max: 0 },
      };

      var sumImpact = 0;
      var sumHijack = 0;

      for (var i = 0; i < allEventData.length; i = i + 1) {
        sumImpact += allEventData[i].impact_score;
        sumHijack += allEventData[i].hijack_score;
        if (allEventData[i].impact_score < allEventDataMinAvgMax.impact.min) {
          allEventDataMinAvgMax.impact.min = allEventData[i].impact_score;
        }
        if (allEventData[i].impact_score > allEventDataMinAvgMax.impact.max) {
          allEventDataMinAvgMax.impact.max = allEventData[i].impact_score;
        }
        if (allEventData[i].hijack_score < allEventDataMinAvgMax.hijack.min) {
          allEventDataMinAvgMax.hijack.min = allEventData[i].hijack_score;
        }
        if (allEventData[i].hijack_score > allEventDataMinAvgMax.hijack.max) {
          allEventDataMinAvgMax.hijack.max = allEventData[i].hijack_score;
        }
      }

      allEventDataMinAvgMax.impact.avg = sumImpact / allEventData.length;
      allEventDataMinAvgMax.hijack.avg = sumHijack / allEventData.length;

      //console.log("Below is the output of the math");
      //console.log(allEventDataMinAvgMax);
      //console.log(sumImpact);

      var barGraphData = {
        labels: ["Hijack", "Impact"],
        datasets: [
          {
            label: "Episode Max",
            data: [
              allEventDataMinAvgMax.hijack.max,
              allEventDataMinAvgMax.impact.max,
            ],
            borderColor: "#b80c00",
            backgroundColor: "#b80c00",
          },
          {
            label: "User Max Threshold",
            data: [userMaxMeanAverage.Max.H, userMaxMeanAverage.Max.I],
            borderColor: "#f53325",
            backgroundColor: "#f53325",
          },
          {
            label: "Episode Min",
            data: [
              allEventDataMinAvgMax.hijack.min,
              allEventDataMinAvgMax.impact.min,
            ],
            borderColor: "#003fb5",
            backgroundColor: "#003fb5",
          },
          {
            label: "User Min Threshold",
            data: [userMaxMeanAverage.Min.H, userMaxMeanAverage.Min.I],
            borderColor: "#2e72f2",
            backgroundColor: "#2e72f2",
          },
          {
            label: "Episode Avg",
            data: [
              allEventDataMinAvgMax.hijack.avg,
              allEventDataMinAvgMax.impact.avg,
            ],
            borderColor: "#00b041",
            backgroundColor: "#00b041",
          },
          {
            label: "User Avg Threshold",
            data: [userMaxMeanAverage.Avg.H, userMaxMeanAverage.Avg.I],
            borderColor: "#2eff7b",
            backgroundColor: "#2eff7b",
          },
        ],
      };
      return barGraphData;
    },
    calcUserMaxMeanAverage: function () {
      var HijackScores = [];
      var ImpactScores = [];
      var ValidationScores = [];

      for (
        var j = 0;
        j < this.$store.state.allASNInfoForOrg.length;
        j = j + 1
      ) {
        HijackScores.push(this.$store.state.allASNInfoForOrg[j].H);
        ImpactScores.push(this.$store.state.allASNInfoForOrg[j].I);
        ValidationScores.push(this.$store.state.allASNInfoForOrg[j].V);
      }

      var MaxMinAvg = {
        Max: { H: "", I: "", V: "" },
        Min: { H: "", I: "", V: "" },
        Avg: { H: "", I: "", V: "" },
      };

      MaxMinAvg.Max.H = Math.max.apply(Math, HijackScores);
      MaxMinAvg.Max.I = Math.max.apply(Math, ImpactScores);
      MaxMinAvg.Max.V = Math.max.apply(Math, ValidationScores);

      MaxMinAvg.Min.H = Math.min.apply(Math, HijackScores);
      MaxMinAvg.Min.I = Math.min.apply(Math, ImpactScores);
      MaxMinAvg.Min.V = Math.min.apply(Math, ValidationScores);

      MaxMinAvg.Avg.H =
        HijackScores.reduce((a, b) => a + b, 0) / HijackScores.length;
      MaxMinAvg.Avg.I =
        ImpactScores.reduce((a, b) => a + b, 0) / ImpactScores.length;
      MaxMinAvg.Avg.V =
        ValidationScores.reduce((a, b) => a + b, 0) / ValidationScores.length;

      return MaxMinAvg;
    },
    convertEpochtoTimeDate: function (epochTime) {
      try {
//        var d_t = new Date(epochTime * 1000);

//        var date = d_t.toLocaleString().substr(0, 10);
//        var time = d_t.toLocaleString().substr(11, 9);

        var dateFormatted = moment.unix(epochTime).tz(this.tz).format('DD/MM/YYYY')
        var timeFormatted = moment.unix(epochTime).tz(this.tz).format('HH:mm:ss')
        var dateTime = { date: dateFormatted, time: timeFormatted, epoch: epochTime };

        return dateTime;
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.manTrTimer);
  },
  watch: {
    $route(to) {
      this.$router.go();
    },
    advanced_fields(n) {
      this.$store.commit("setShowSettings", { clickthroughAdvFields: n });
    },
  },
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 38px;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}

.tr-back {
  background-color: #1976d2;
  color: white;
}
</style>
